import { Component, Inject, ElementRef, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main/main.service';
import { email_regex, mobile_mask } from 'src/app/shared/regex';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl, UntypedFormGroup, Validators, NgForm, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { LoaderService } from 'src/app/services/interceptor/loader.service';
import { environment } from 'src/environments/environment';
import { PlaidService } from 'src/app/services/plaid/plaid.service';
// import { Intercom } from 'ng-intercom';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DialogContentExampleDialog } from 'src/app/pages/trainings/video-tutorials/video-tutorials.component';
import { PersonaService } from 'src/app/services/persona/persona.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import * as Regex from 'src/app/shared/regex'
import { GlobalFilterObj, ALL_LOCATIONS_FILTER } from 'src/app/services/shared/global-filter.service';
import { read, utils } from 'xlsx';
import { StripeService } from 'src/app/services/stripe/stripe.service';
import { PrepaidCardService } from '../prepaid-card-modal/prepaid-card.service';
import { PROPOSAL_DURATIONS, SUBSCRIPTION_CHANGE_APIS } from '../../core/constants/shared-data.constants';
import { getUserProfile, getUserProfiles, getDoctorSettings, getStoredLocations } from 'src/app/core/session';
declare var Intercom: any;

export interface TrainingType {
    duration: Number;
    description: string;
    name: string;
  }

@Component({
    selector: 'app-simple-dialog',
    templateUrl: 'simple-dialog.component.html',
    styleUrls: ['./simple-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SimpleDialogComponent {
    public mask = mobile_mask;
    public contractData: any;
    public cancel_contract_step: number = 1;
    public selected_option: any;
    public payment_option: any;
    public payment_result: any;
    public payment_stripe_data: any;
    public edit_recurring_step: number = 1;
    public edit_recurring_data: any = {};
    public loader: boolean = false;
    public send_email: any;
    public send_phone: any;
    public missing_payments: any = [];
    public userDetails: UntypedFormGroup;
    public serviceBreakDown: any[] = [
        {
            service: '',
            price: '',
            contract_id: '',
            service_id: ''
        }
    ];
    currentYear: number = new Date().getFullYear();
    totalServAmt: number;
    public contract_id: number;
    separatorKeysCodes: number[] = [ENTER];
    emailCtrl = new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern(email_regex)]);
    emails: string[] = [];
    environment: any = localStorage.getItem('environment') || '';
    proposalSent = false;
    fillForm = false;
    proposalStartDate: any = {};
    proposalEndDate: any = {};
    changeReason: string = '';
    proposalDuration: any = PROPOSAL_DURATIONS;

    business_challenge:any = {};
    dynamicMonth = moment().format('MMMM').toLowerCase();
    timeRemaining: string = '';
    intervalId: any;
    countdownDate = new Date().getTime();
    remaining_days: number;
    extra_days=0;
    selectedPayoutOption:any;
    amazonPayEmail: string = '';
    resaonValue:any;

    languages = JSON.parse(localStorage.getItem('languages')) ;
    languageSelected: any;
    selected_location1: GlobalFilterObj = { ...ALL_LOCATIONS_FILTER };
    show_desc: Boolean = false;
    proposalDurationModel = this.proposalDuration[3].value;
    callReasonModel: any;
    responseSubmitted = false;
    @ViewChild('emailInput', { static: false }) emailInput: ElementRef<HTMLInputElement>;
    new_address: {
        new_address_1?: string,
        new_address_2?: string,
        state?: string,
        zip_code?: string,
        city?: string,
        checked?: boolean,
        country?: string,
        cardError?: string,
        saveDefault?: string,
        country_code?: string
    } = {};
    add_product = {
        website_navigation_link: '',
        doctor_id: null,
        pc_id: null,
        pc_name: '',
        service_amount: null,
        dp_amount: null,
        terms: '',
        description: '',
        show_desc: 0,
        contract_type: null,
        interest_rate: null
    };
    dynamicPackage = {
        website_navigation_link: '',
        service_name: "",
        description: "",
        min_down_payment: 0,
        service_amount: null,
        add_package_list: [],
        edit_dynamic_package_index: -1,
        terms_type: 1,
        terms: '',
        show_input_value_container: true,
        doctor_id: "",
        show_desc: "",
        interest_rate: null,
        amount_terms_type: 1
    };
    userInfo = getUserProfiles();
    doctorSettings = localStorage.getItem('doctorSettings') ? getDoctorSettings() : {};
    selectedProfileImage = this.userInfo[0].doctor_image || this.userInfo[0].profile_image || 'assets/img/png/profile_placeholder.png';
    add_dynamic_product_temp: { terms: any; service_amount: any; dp_amount: any; terms_type: any; interest_rate: Number, amount_terms_type: number };
    confirmation = "";
    addCardForm: UntypedFormGroup;
    zipCode: any;
    showAddressField: boolean = true;
    iscardSubmitted: boolean;
    submitted: boolean;
    serviceBreakForm: UntypedFormGroup;
    currentPath= window.location.pathname;
    resendNotes: any = '';
    cancelNotes: any = '';
    timezones: any = [];
    item: UntypedFormArray;
    doc_uploaded_disabled: boolean = true;
    other_reason: string;
    reason:any[] = [];
    reasonsData: any;
    add_proposal_users = [];
    edit_proposal_index = -1;
    csv_proposal_array: any;
    editpatientVal= false;
    showNewInputs= true;
    user_obj: { patient_first_name: any; patient_last_name: any; patient_email: any; patient_mobile: any; };
    showCloseBtn: boolean;
    pot_contract_type: any;
    pot_contract_step: any = 1;
    financing_type: any;
    can_finance: any;
    downLimit: any;
    changeSubApis = SUBSCRIPTION_CHANGE_APIS;
    subscibtion_plan_data: any;
    showcancell: boolean;
    selectDeafultCard = false;
    card_index = null;
    card_object = {};
    download_receipt_link = environment.download_receipt_link
    doctorProfile=localStorage.getItem("doctorProfile")?JSON.parse(localStorage.getItem("doctorProfile")):{}
    downpayment_setting=this.doctorProfile && this.doctorProfile.downpayment_setting ? this.doctorProfile.downpayment_setting: '';
    notify_checkbox = true;
    // Training variables
    training_types = [];
    training_timezones = [];
    current_timezone;
    training_type;
    selected_training: TrainingType;
    offsetFromCurrentWeek = 0;
    training_data = [];
    user_info = getUserProfiles();
    today = new Date();
    timezone: string;
    selectedDate: string;
    isWeekend: boolean;
    lastDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 35)
    selected_training_data = {
        selected_time_lots: [],
        selected_index: -1,
        selected_date: "",
        schedule_time_slot: "",
        selected_full_date_time_string: ""
      }
    openboxes: boolean = false;
    selected_timeslot = null;
    locations: any = [];
    training_booked = 0;
    training_booked_data: { training_time: string; training_date: string; timezone: string; } = { training_time: '', training_date: '', timezone: '', };
    availableTimeslots: any[] = [];
    passEror = false;
    arTerm = this.fb.group({
        terms: [false, Validators.requiredTrue]
      });
    instant_payout_config: any = getUserProfile().instant_payout_config;
    cardholderName: string = ''
    cardComplete: boolean = false;
    cardElement: any;
    is_opt_disabled: boolean = false;
    show_additional_service: boolean = false
    time: any;
    interval: NodeJS.Timeout;
    timerDisplay: string;
    contract: any;
    show_pp_subscription:any;
    show100DollarChallange: any = 0;
    constructor(
        public mainService: MainService,
        public dialogRef: MatDialogRef<SimpleDialogComponent>,
        public auth: AuthService,
        public dialog: MatDialog,
        public loaderService: LoaderService,
        public plaidService: PlaidService,
        private zone: NgZone,
        // public intercom: Intercom,
        private fb: UntypedFormBuilder,
        public router: Router,
        public _shared: SharedService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public datepipe: DatePipe,
        public _persona: PersonaService,
        private stripe: StripeService,
        private prepaidCard: PrepaidCardService,
    ) {
        this.initAddCard();
        let selected= this.languages.filter((ele:any)=>{
            if(ele.lan_code == "en"){
              return ele.lan_code;
            }
        })
        this.languageSelected = selected[0].lan_code;
        this.auth.doctorDefaultVales$.subscribe((data) => {
            this.doctorSettings = data;
            this.financing_type = data.pot_financing_type;
        })
        this.subscibtion_plan_data = this.mainService.subscription_data;
    }

    initBreakdownForm() {
        this.serviceBreakForm = this.fb.group({
            items: new UntypedFormArray([]),
            addOns: new UntypedFormArray([]),
        })
    }

    initAddCard() {
        this.addCardForm = this.fb.group({
            new_address_1: ['', [Validators.required]],
            new_address_2: [''],
            state: [{ value: "", disabled: true }],
            zip_code: ['', [Validators.required]],
            city: [{ value: "", disabled: false },[Validators.required]],
            checked: [''],
            country: [''],
            saveDefault: [''],
            country_code: [''],
            cardholder_name: ['', [Validators.required]]
        })
    }

    getAddressForm() {
        this.showAddressField = !this.showAddressField;

        if (!this.showAddressField) {
            const arr1 = ['new_address_1', 'zip_code', 'city', 'state']
            for (let i of arr1) {
                this.addCardForm.controls[i].clearValidators();
                this.addCardForm.controls[i].updateValueAndValidity();
            }
        }
        else {
            this.addCardForm.controls.checked.setValue(false);
            const arr1 = ['new_address_1', 'zip_code','city', 'state']
            for (let i of arr1) {
                this.addCardForm.controls[i].setValidators(Validators.required);
                this.addCardForm.controls[i].updateValueAndValidity();
            }
        }
    }

    getAddressFormV2() {
        this.showAddressField = !this.showAddressField;
        if (this.showAddressField) {
            this.addCardForm.patchValue({
                cardholder_name: '',
                new_address_1: '',
                new_address_2: '',
                city: '',
                state: '',
                zip_code: '',
                country_code: '',
            })
            this.zipCode = '';
            this.addCardForm.get('state').setValue(this.data.send_data.state || '');
            return
        }
        this.addCardForm.patchValue({
            cardholder_name: this.data.send_data.patient_name,
            new_address_1: this.data.send_data.address_1,
            new_address_2: this.data.send_data.address_2,
            city: this.data.send_data.city || '',
            state: this.data.send_data.state || '',
            zip_code: this.data.send_data.zip_code,
            country_code: this.data.send_data.country_code || 'US',
        })

        this.addCardForm.get('state').setValue(this.data.send_data.state || '');
    }

    ngOnInit() {
        this.show100DollarChallange = this.user_info && this.user_info[0] && this.user_info[0].show_100_dollar_challenge || 0;
        this.dialogRef.disableClose = true;
        let userData = localStorage.getItem("userProfileData")?getUserProfiles():{}

        if(this.data && this.doctorProfile && userData[0].business_verification_state == 'verification_processing') {
          this.data.type = 944
        }

        this.show_pp_subscription = this.data.isPPSub;


        if (this.data && this.data.type == 99) {
            this.dialogRef.disableClose = true;
        }
        if (this.data && this.data.type == 8 || this.data.type == 2 || this.data.type == 14 || this.data.type == 15 || this.data.type == 11 || this.data.type == 12 || this.data.type == 9 || this.data.type == 7) {
            // cdk-overlay-pane
            setTimeout(() => {
                document.getElementsByClassName('cdk-overlay-pane')[0].classList.add('unset_width')
            }, 100)
        }
        if (this.data && this.data.type == 44) {
            this.dialogRef.disableClose = true;
        }
        if (this.data && this.data.type == 7) {
            this.setCancelContractData(this.data);
        }
        if (this.data && this.data.type == 48) {
            this.setEditContractData(this.data);
        }
        if (this.data && this.data.type == 9) {
            this.setChangePaymentDateData(this.data);
            this.changePaymentDateCard = this.contractData.payment_sources[0];
        }
        if (this.data && this.data.type == 10) {
            this.contractData = this.data.send_data;
        }
        if (this.data && this.data.type == 13) {
            this.contractData = this.data.send_data;
        }
        if (this.data && this.data.type == 14) {
            this.send_email = this.data.send_data.patient_email
        }

        if (this.data && (this.data.type == 15 || this.data.type == 51)) {
            setTimeout(() => {
                this.mountCard();
            }, 100)
        }

        if (this.data && (this.data.type == 20 || this.data.type == 603 || this.data.type == 604 || this.data.type == 704)) {
            this.payment_option = {};
            setTimeout(() => {
                this.mainService.stripe_element.mount('#' + 'add_card');
            }, 1000);
        }
        if (this.data && this.data.type == 19) {
            this.proposalEndDate = moment(moment(new Date()).utc().add(6, 'M').unix() * 1000);
            this.proposalStartDate = moment(moment(new Date()).utc().add(1, 'd').unix() * 1000);

            if (this.data.send_data.user_phone.includes('+1-')) {
                this.data.send_data.user_phone = this.data.send_data.user_phone.replace('+1-', '');
            }
            if (this.data.allContracts) {
                this.checkboxed = this.data.allContracts.filter((item) => {
                    return item.checked == true || item.checked == 1
                })

                this.data.allContracts = this.data.allContracts.reduce((item, o) => {
                    if(!item.some(obj => obj.month === o.month)) {
                      item.push(o);
                    }
                    return item;
                },[]);
            }
            else {
                this.fillForm = true;
            }
        }

        if (this.data && this.data.type == 21) {
            this.initBreakdownForm();

            this.contract_id = this.data.send_data.contract_id;
            this.totalServAmt = this.data.send_data.service_cost ? this.data.send_data.service_cost : 0;
            this.data.send_data.action_button = 'Add';
            if (this.data.send_data.services.length) {
                for (let item of this.data.send_data.services) {
                    this.setBreakdownVal(item)
                }
                this.serviceBreakDown = [];
                this.serviceBreakDown = this.data.send_data.services;
                this.data.title = 'Service Cost Breakdown';
                this.data.send_data.action_button = 'Update';

            }

            this.services();
        }
        if (this.data && this.data.type == 23) {
            this.contract_id = this.data.send_data.contract_id
        }
        if (this.data && this.data.type == 25) {
            if (this.data.send_data.selected_option) {
                this.callReasonModel = this.data.send_data.reason[5].reason;
            } else {
                this.callReasonModel = this.data.send_data.reason[0].reason;
            }
            this.reasonPrioritySet(this.callReasonModel);
        }
        if (this.data && this.data.type == 26) {
            this.data.send_data.new_source_id = this.data.send_data.source_id;
            this.data.send_data.new_secondary_source_id = this.data.send_data.secondary_source_id;
        }
        if (this.data && this.data.type == 32) {
            this.verifyingCustomer();
        }
        if (this.data && this.data.type == 35) {
            this.payment_option = {};
            setTimeout(() => {
                if (!this.data.send_data.acc_details.auth_card.length) {
                    this.mainService.stripe_element.unmount('#' + 'pp_add_card')
                    this.mainService.stripe_element.mount('#' + 'pp_add_card');
                }
            }, 2000);
        }
        if (this.data && this.data.type == 37) {
            this.payment_option = {};
            setTimeout(() => {
                this.mainService.stripe_element.mount('#' + 'add_instant_card');
            }, 2000);
        }
        if (this.data.type == 38) {
            this.getFilteredInstantPayoutSupoortBanks('');
            this.banks = this.data.send_data.cardlist.data;
        }
        if (this.data.type == 39) {
            if (this.data.send_data.add_product && this.data.send_data.add_product.pc_id) {
                this.add_product = this.data.send_data.add_product;
            }
            if (this.data.send_data.doctor_id) {
                this.add_product.doctor_id = this.data.send_data.doctor_id;
            }
        }
        if (this.data.type == 50) {
            this.initBreakdownForm();
            this.downLimit = 30;
            if (this.data.send_data.add_product && this.data.send_data.add_product.contract_type == 2) {
                this.downLimit = this.doctorSettings.downpayment_percent;
            } else if (this.data.send_data.add_product && this.data.send_data.add_product.contract_type == 6) {
                this.downLimit = this.doctorSettings.di_downpayment_percent;
            } else {
                this.downLimit = this.doctorSettings.new_ten_downpayment_percent;
            }
            if (this.data.send_data.add_product && this.data.send_data.add_product.pc_id) {
                this.dynamicPackage["pc_id"] = this.data.send_data.add_product.pc_id;
                this.dynamicPackage.service_name = this.data.send_data.add_product.pc_name;
                this.dynamicPackage.add_package_list = this.data.send_data.add_product.products_array;
                this.dynamicPackage.add_package_list.filter((ele:any)=> {
                    ele.service_amount_type = this.data.send_data.add_product.service_amount_type;
                })
                this.dynamicPackage.show_input_value_container = false;
                this.dynamicPackage.description = this.data.send_data.add_product.description;
                this.dynamicPackage.website_navigation_link = this.data.send_data.add_product.website_navigation_link;
                this.dynamicPackage.show_desc = this.data.send_data.add_product.show_desc;
                this.dynamicPackage.amount_terms_type = this.data.send_data.add_product.service_amount_type;
                this.data.send_data.add_product.additional_products_array= JSON.parse(this.data.send_data.add_product.additional_products_array);
                if(this.data.send_data.add_product.additional_products_array != null) {
                    this.show_additional_service = true;
                    for (let item of this.data.send_data.add_product.additional_products_array) {
                        this.setBreakdownVal(item);
                    }
                }
            }
            if (this.data.send_data.doctor_id) {
                this.dynamicPackage.doctor_id = this.data.send_data.doctor_id;
            }
        }
        if (this.data && this.data.type == 43) {
            this.getTutorialVideos();
        }
        if (this.data && (this.data.type == 46 || this.data.type == 47)) {
            this.getCMSHTML();
        }


        if (this.data.type == 210) {
            this.userDetails = this.fb.group({
                "access_token": localStorage.getItem('token'),
                "name": ["", [Validators.required, Validators.pattern(Regex.Name_1)]],
                "email": ["", [Validators.required, Validators.pattern(email_regex)]],
                "doctor_id": getUserProfiles() && getUserProfile().doctor_id,
            })
            if (this.data.send_data && this.data.send_data) {
                // let datanew = this.data.send_data;
                // datanew.mobile = datanew.mobile.split('-')[1]
                this.userDetails.patchValue(this.data.send_data);
            }
            if (this.data && this.data.error) {
                setTimeout(() => {
                    if (this.data.error_name) {
                        this.userDetails.controls[this.data.error_name.trim().toLowerCase().indexOf('mobile') >= 0 ? 'mobile' : this.data.error_name.trim().toLowerCase().indexOf('email') >= 0 ? 'email' : this.data.error_name.trim().toLowerCase().indexOf('username') >= 0 ? 'name' : this.data.error_name == "User Exist for the selected location" ? 'mobile' : ''].setErrors({ error: this.data.error_name })
                    }
                    this.data.error_name = this.data.error_name == "User Exist for the selected location" ? 'Mobile number already associated with another user.' : this.data.error_name;
                    this.userDetails.markAllAsTouched();
                    this.userDetails.markAsDirty();
                    this.userDetails.updateValueAndValidity()
                }, 100)
            }
        }

        if((this.data.type == 39 || this.data.type == 50) && !this.data.send_data.pf_id) {
            this.add_product.contract_type = this.data.send_data.add_product.contract_type;
            this.add_product.interest_rate = this.add_product.interest_rate != null ? this.add_product.interest_rate: String(this.doctorSettings.guarantee_percent_new_ten);
            this.dynamicPackage.interest_rate = this.doctorSettings.guarantee_percent_new_ten;
        }

        if (this.data.type == 216) {
            this.financing_type = this.data.send_data.add_product.financing_type;
            this.can_finance = this.data.send_data.add_product.can_finance;
            if (this.data.send_data.add_product.financing_type === 2) {
                this.pot_contract_type = 2;
                this.pot_contract_step = 2;
            }
            else if (this.data.send_data.add_product.financing_type === 4) {
                this.pot_contract_type = 3;
                this.pot_contract_step = 2;
            }
            else if (this.data.send_data.add_product.financing_type === 3) {
                this.pot_contract_type = 2;
                this.pot_contract_step = 2;
            }
            else {
                this.pot_contract_type = 1;
                this.pot_contract_step = 1;
            }
        }
        if (this.data.type == 761) {
          this.reasonsData = this.data.send_data;
        }

        if(this.data.type == 999){
            this.data.allContracts = this.data.allContracts.reduce((item, o) => {
                if(!item.some(obj => obj.month === o.month)) {
                  item.push(o);
                }
                return item;
            },[]);
        }

        if(this.data.type == 806 || this.data.type == 805 || this.data.type == 803 || this.data.type == 804){
            this.business_challenge = this.data.send_data;
            this.startCountdown();
        }

        if(this.data.type == 802) {
            this.selectedDate = this.datepipe.transform(this.today, 'yyyy-MM-dd', this.timezone);
            var dayOfWeek = this.today.getDay();
            this.lastDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 35)
            this.isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
            if (this.isWeekend) {
                this.mainService.customPopups("Please choose another date.Training can't be scheduled on weekend", 1);
                setTimeout(() => {
                    this.dialogRef.close();
                  });
            }
            else {
                this.fetchTrainingTypes();
            }
            this.timezone = this.mainService.getCurrentTimezone();
            // this.old_event_id = this._routes.snapshot.params['event_id']
            // this.timezones = this.data.timezones;
        }
        if(this.data.type == 901) {
            this.selectedDate = this.datepipe.transform(this.today, 'yyyy-MM-dd', this.timezone);
            var dayOfWeek = this.today.getDay();
            this.lastDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 35)
            this.isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
            if (this.isWeekend) {
                this.mainService.customPopups("Please choose another date.Training can't be scheduled on weekend", 1);
                setTimeout(() => {
                    this.dialogRef.close();
                  });
            }
            else {
                this.fetchTrainingTypes();
            }
            this.timezone = this.mainService.getCurrentTimezone();
        }


        // if(this.data.type == 805){
        //     this.selectedPayoutOption = this.data.send_data.type;
        //     this.business_challenge = this.data.send_data.business_challenge;
        // }
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        const lastDay = new Date(currentYear, currentMonth + 1, 0);
        lastDay.setHours(23, 59, 0, 0);
        this.countdownDate = lastDay.getTime();

        if(this.data.type == 946){
            setTimeout(()=>{
                this.cardElement = this.mainService.stripe_element;
                this.cardElement.mount('#add_instant_card');
                this.cardElement.on('change', (event: any)=>{
                    this.cardComplete = event.complete;
                    console.log('cardcomplete',this.cardComplete);
                })
            },500);
        }

    }

    async mountCard() {
        let data = {
          isMountAddress: true,
          patient_id: this.data.send_data.patient_id,
        }
        if(this.data.type == 51){
          data["doctor_id"] = this.data.send_data.user_info.doctor_id;
        }
        await this.stripe.createStripeElement(data);
        this.stripe.paymentElement.on('change', (event: any) => {
          this.checkAllElementsComplete(event, 'card');
        });

        this.stripe.addressElement.on('change', (event: any) => {
          this.checkAllElementsComplete(event, 'address');
        });

      }


    cardElementComplete = false;
    addressElementComplete = false;
      checkAllElementsComplete = (event, elementType) => {
        if (elementType === 'card') {
          this.cardElementComplete = event.complete;
        } else if (elementType === 'address') {
          this.addressElementComplete = event.complete;
          this.addCardForm.patchValue({
            cardholder_name: event.value.name,
            new_address_1: event.value.address.line1,
            new_address_2: event.value.address.line2,
            city: event.value.address.city,
            state: event.value.address.state,
            zip_code: event.value.address.postal_code,
            country: event.value.address.country,
            country_code: event.value.address.country,
          })
        }
        if (this.cardElementComplete && this.addressElementComplete) {
          let source = event.elementType === 'address' ? event.value.address : this.addCardForm.value;
          this.zipObj = {
            zip: source.postal_code || source.zip_code,
            state_name: source.state || this.addCardForm.controls.state.value,
            state_code: source.state || this.addCardForm.controls.state.value,
            city: source.city,
            country_name: source.country,
            country_code: source.country
          };
        }
      };

    claimReward() {
        try {
            if (!this.selectedPayoutOption) {
                return this.mainService.customPopups('Please select an option', 2);
            }
            let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

            if (this.selectedPayoutOption == 2 && (!this.amazonPayEmail || this.amazonPayEmail.trim() == '' || !EMAIL_REGEXP.test(this.amazonPayEmail))) {
                return this.mainService.customPopups('Please enter an email address', 2);
            }
            let data = {
                access_token: localStorage.getItem('token'),
                selected_payout_option: this.selectedPayoutOption,
                amazonPayEmail: this.amazonPayEmail.trim(),
                challenge_month : this.data.send_data.challenge_month
            };
            this.mainService.api(data, 'send_business_challenge_share', false).subscribe(
                (response) => {
                    if (response.is_error) {
                        this.mainService.customPopups(response.err, 1);
                    } else {
                        this.dialogRef.close(this.selectedPayoutOption);
                    }
                }
            );
        } catch (error) {
            this.mainService.customPopups('Unexpected error', 1);
            console.error('Unexpected error:', error);
        }
    }

    startChallenge(): void {
        try {
            if (this.business_challenge) {
                this.router.navigate(['/app/finance']);
                this.dialogRef.close(1)
            }
        } catch (error) {
            console.log(error);
        }
    }
    addUser() {
        let data = this.userDetails.value;
        data.name = this.userDetails.value.name.trim();
        if (this.data.send_data && this.data.send_data.doctor_id) {
            data.doctor_id = this.data.send_data.doctor_id;
        }
        this.mainService.api(data, `add_enterprise_agent`, true, 'object')
            .subscribe(response => {
                if (response.is_error == 0) {
                    this.dialogRef.close(1)
                } else {
                    setTimeout(() => {
                        let error = data.override_text || data.err;
                        if (error) {
                            this.userDetails.controls[error.trim().toLowerCase().indexOf('mobile') >= 0 ? 'mobile' : error.trim().toLowerCase().indexOf('email') >= 0 ? 'email' : error.trim().toLowerCase().indexOf('username') >= 0 ? 'name' : error == "User Exist for the selected location" ? 'mobile' : ''].setErrors({ error: error })
                        }
                        error = error == "User Exist for the selected location" ? 'Mobile number already associated with another user.' : error;
                        this.userDetails.markAllAsTouched();
                        this.userDetails.markAsDirty();
                        this.userDetails.updateValueAndValidity()
                    }, 100)
                }
            });
    }

    get serviceBreakdowns(): UntypedFormArray {
        return this.serviceBreakForm.get("items") as UntypedFormArray;
    }

    get selected_additional_product_array(): UntypedFormArray {
        return this.serviceBreakForm.get("addOns") as UntypedFormArray;
    }

    createItem(): UntypedFormGroup {
        return this.fb.group({
            service: ['', [Validators.required]],
            price: ['', [Validators.required]],
        });
    }

    setBreakdownVal(data) {
        let body = {
            price: data.price,
            service: data.service
        }
        if(data.isAddOn){
            this.selected_additional_product_array.push(this.createGroup({...body, isAddOn: true}));
        } else {
            this.serviceBreakdowns.push(this.createGroup(body));
        }
    }

    createGroup(body) {
        return this.fb.group({
            service: [body.service, [Validators.required]],
            price: [body.price, [Validators.required]],
            isAddOn: [body.isAddOn ? body.isAddOn : false, [Validators.required]],
        })
    }

    addGroup(isAddOn) {
        if (this.serviceBreakForm.invalid) {
            this.serviceBreakForm.markAsTouched();
            this.serviceBreakForm.markAllAsTouched();
            this.serviceBreakForm.markAsDirty();
            return
        }
        if (this.serviceBreakForm.valid) {
            this.item = this.serviceBreakForm.get("items") as UntypedFormArray;
            if(isAddOn){
                this.selected_additional_product_array.push(this.createGroup({service: '', price: '', isAddOn: true}));
            } else {
                this.serviceBreakdowns.push(this.createItem())
            }
        }
    }


    deleteGroup(i, isAddOn) {
        if(isAddOn){
            this.selected_additional_product_array.removeAt(i);
        } else {
            this.serviceBreakdowns.removeAt(i);
        }
    }

    validateNumValue(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    public onChange(d) {
        var date = new Date();
        if (!isNaN(d)) {
            this.proposalEndDate = moment(moment(date).utc().add(d, 'M').unix() * 1000);
            if (d > 12) {
                this.proposalEndDate = moment(moment(date).utc().add(15, 'd').unix() * 1000);
            }
        }
    }

    public confirmAction() {
        if(this.data.reasons && this.data.reasons.length) {
            if(!this.resaonValue) return this.mainService.customPopups("Please select a valid reason",1);
            if(this.resaonValue == 5 && (!this.other_reason || !this.other_reason.trim())) return this.mainService.customPopups("Please enter a valid reason",1);
            this.dialogRef.close({reason: this.other_reason || this.resaonValue, result: 1})
        } else if(this.data.actionClass == 'resend__sub__link' && this.data.showCheckbox) {
            let type = this.notify_checkbox ? 2 : 1;
            this.canCelSubs(type);
        } else if(this.data.actionClass == 'resend__sub__link' && this.data.action == 'Resend'){
            this.dialogRef.close(2);
        } else {
            // let id = this.data?.send_data?.id
            this.dialogRef.close(1);
        }
    }

    public closeAction() {
        this.dialogRef.close(0);
    }

    public getTransactionFee(contract, comparable_value) {
        comparable_value = parseFloat(comparable_value);
        contract.recurring_extra_amount = parseFloat(contract.recurring_extra_amount);
        contract.recurring_extra_percent = parseFloat(contract.recurring_extra_percent);
        contract.threshold_amount = parseFloat(contract.threshold_amount);
        contract.threshold_recurring_extra_amount = parseFloat(contract.threshold_recurring_extra_amount);
        contract.threshold_recurring_extra_percent = parseFloat(contract.threshold_recurring_extra_percent);
        let text = '';
        if (comparable_value < contract.threshold_amount) {
            if (contract.recurring_extra_percent) {
                text += `${parseFloat(contract.recurring_extra_percent).toFixed(2)}%`
            }
            if (contract.recurring_extra_amount && contract.recurring_extra_percent) {
                text += ' + ';
            }
            if (contract.recurring_extra_amount) {
                text += `$${parseFloat(contract.recurring_extra_amount).toFixed(2)}`
            }
        } else {
            if (contract.threshold_recurring_extra_percent) {
                text += `${parseFloat(contract.threshold_recurring_extra_percent).toFixed(2)}%`
            }
            if (contract.threshold_recurring_extra_amount && contract.threshold_recurring_extra_percent) {
                text += ' + ';
            }
            if (contract.threshold_recurring_extra_amount) {
                text += `$${parseFloat(contract.threshold_recurring_extra_amount).toFixed(2)}`
            }
        }
        return text;
    }

    public resendLink(form) {
        if (form && !form.value.user_email && !form.value.user_phone) {
            this.mainService.customPopups('Please enter valid email or phone number', 3);
            return false;
        }
        var mobile = form && form.value.user_phone ? form.value.user_phone.replace(/-/g, '') : null;
        if (mobile && mobile.length < 9) {
            this.mainService.customPopups('Please enter valid phone number', 3);
            return false;
        }
        if (!this.languageSelected && this.languageSelected == undefined) {
            this.mainService.customPopups('Please enter communication language', 3);
            return false;
        }
        const data:any = {
            access_token: localStorage.getItem('token'),
            id: this.data.send_data.id,
            email: form.value.user_email,
            mobile: mobile,
            is_ar: this.data.send_data.is_ar,
            language_preferred: this.languageSelected
        };
        if(this.resendNotes){
            data.notes = this.resendNotes;
        }
        this.mainService.api(data, this.data.send_data.api_url ? this.data.send_data.api_url : 'resend_payment_process_link', false)
            .subscribe((data: any) => {
                if (data && data.is_error == 0) {
                    if (data.flag == 552) {
                        this.mainService.customPopups(data.data, 0);
                    } else {
                        if(this.data.send_data.api_url){
                            this.mainService.customPopups('The subscription plan have been successfully re-sent.', 0);
                        } else {
                            this.mainService.customPopups('Payment invoice sent to the customer successfully.', 0);
                        }

                    }
                    this.confirmAction();
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        this.mainService.customPopups(data.override_text, data.is_error);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    public sendReceiptLink(form) {
        if (form && !(form.value.user_email || form.value.user_phone)) {
            this.mainService.customPopups('Please enter valid email or phone number', 1);
            return false;
        }
        var mobile = form && form.value.user_phone ? form.value.user_phone.replace(/-/g, '') : null;
        const data = {
            access_token: localStorage.getItem('token'),
            id: this.data.send_data.id,
            email: form.value.user_email,
            mobile: mobile,
            is_ar: this.data.send_data.is_ar,
            language_preferred: this.languageSelected
        };
        this.mainService.api(data, this.data.send_data.api_url || 'send_download_receipt_link', false)
            .subscribe((data: any) => {
                if (data && data.is_error == 0) {
                    if (data.flag == 552) {
                        this.mainService.customPopups(data.data.override_text ? data.data.override_text: data.data, 0);
                    } else {
                        this.mainService.customPopups('Payment Receipt has been sent successfully.', 0);
                    }
                    this.confirmAction();
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        this.mainService.customPopups(data.override_text, data.is_error);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    public setCancelContractData(data) {
        this.contractData = data.send_data;
        if (this.contractData.pf_status == 3 && !this.contractData.gp_recovered) {
            return;
        }
        this.cancel_contract_step = 1;
        this.payment_stripe_data = {};
        this.selected_option = null;
        this.payment_result = {};
        this.payment_option = {};
        setTimeout(() => {
            this.mainService.stripe_element.mount('#' + 'cancel_contract');
        }, 1000);

        //Remove bank form bank array
        this.changePaymentDateCardList = this.contractData.payment_sources.filter((item, index) => {
            return item.payment_source !== "Bank"
        });
        let default_card = this.changePaymentDateCardList.filter(card => card.source_id == this.contractData.source_id);
        if (default_card && default_card[0]) {
            this.selPaymentCard(default_card[0]);
        }
    }
    edit_contract_data = {
        terms: null,
        selected_card: null,
        minimum_amount: null,
        maximum_amount: null,
        minimum_tenure: null,
        maximum_tenure: null,
        cardName: null,
        advance_interest_amount: null,
        tenure: null,
        new_recurring_amount: null,
        treatment_amount: null,
        notes: '',
        oldFinanceDetails: {
            "interest_rate": null,
            "interest_rate_to_show": null,
            "number_of_payments": null,
            "treatment_amount": null,
            "financed_amount": null,
            "downpayment_amount": null,
            "recurring_amount": null,
            "remaining_payments": null,
            "advance_interest_amount": null,
            "recurring_extra_amount": null,
            "recurring_extra_percent": null,
            "threshold_amount": null,
            "threshold_recurring_extra_amount": null,
            "threshold_recurring_extra_percent": null
        },
        newFinanceDetails: {
            "interest_rate": null,
            "interest_rate_to_show": null,
            "number_of_payments": null,
            "treatment_amount": null,
            "financed_amount": null,
            "downpayment_amount": null,
            "recurring_amount": null,
            "remaining_payments": null,
            "advance_interest_amount": null,
            "recurring_extra_amount": null,
            "recurring_extra_percent": null,
            "threshold_amount": null,
            "threshold_recurring_extra_amount": null,
            "threshold_recurring_extra_percent": null
        }
    };
    edit_contract_step = 1;
    plan_array = [];
    editContractResult = {
        is_error: 0,
        override_text: null
    }
    editContractStripeData = {
        token: {
            id: null,
            card: {
                last4: null
            }
        }
    }
    gotoNextStepEditContract() {
        if (this.edit_contract_step === 1) {
            this.edit_contract_data['treatment_amount'] = parseFloat(this.edit_contract_data['treatment_amount']);
            if (!this.edit_contract_data['treatment_amount']) {
                this.mainService.customPopups('Please enter a valid finance amount', 1);
                return;
            }
            this.setRecurringData();
        } else if (this.edit_contract_step === 2) {
            if (!this.plan_array || this.plan_array.length == 0) {
                return;
            }
            if (!this.edit_contract_data['tenure'] && !this.edit_contract_data['new_recurring_amount']) {
                this.mainService.customPopups('Please enter a valid new tenure or recurring amount', 1);
                return;
            }
            if (this.edit_contract_data['tenure']) {
                if (!this.edit_contract_data['new_recurring_amount']) {
                    var maximum_tenure = Math.max.apply(Math, this.plan_array.map(item => item.month));
                    var minimum_tenure = Math.min.apply(Math, this.plan_array.map(item => item.month));
                    if (this.edit_contract_data['tenure'] > maximum_tenure) {
                        this.mainService.customPopups('New tenure should be less than or equal to ' + maximum_tenure + ' months', 1);
                        return;
                    }
                    if (this.edit_contract_data['tenure'] < minimum_tenure) {
                        this.mainService.customPopups('New tenure should be greater than or equal to ' + minimum_tenure + ' months', 1);
                        return;
                    }
                }
            }
            if (this.edit_contract_data['tenure'] && this.edit_contract_data['new_recurring_amount']) {
                this.edit_contract_step = 3;
            }
            if (!this.edit_contract_data['tenure']) {
                var max_recurring = Math.max.apply(Math, this.plan_array.map(item => item.new_recurring_amount_with_fee));
                var min_recurring = Math.min.apply(Math, this.plan_array.map(item => item.new_recurring_amount_with_fee));
                if (this.edit_contract_data['new_recurring_amount'] > max_recurring) {
                    this.mainService.customPopups('New recurring amount should be less than or equal to $' + max_recurring, 1);
                    return;
                }
                if (this.edit_contract_data['new_recurring_amount'] < min_recurring) {
                    this.mainService.customPopups('New recurring amount should be greater than or equal to $' + min_recurring, 1);
                    return;
                }
                this.getNearestPlan(this.edit_contract_data['new_recurring_amount']);
            }
        } else if (this.edit_contract_step === 3) {
            this.getEditFinanceCompareV2();
        } else if (this.edit_contract_step === 4) {
            if (this.edit_contract_data['newFinanceDetails'].advance_interest_amount > this.edit_contract_data['oldFinanceDetails'].advance_interest_amount) {
                this.edit_contract_step = this.edit_contract_step + 1;
                return false;
            } else {
                this.edit_contract_step = this.edit_contract_step + 2;
                return false;
            }
        } else if (this.edit_contract_step === 5) {
            if (!this.payment_option.paymentType) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 1 && !(this.selected_option == 1 || this.selected_option == 4 || this.selected_option == 5)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 2 && !(this.selected_option == 2 || this.selected_option == 3)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.selected_option == 2 || this.selected_option == 4) {
                this.createStripeToken('edit_contract');
            } else {
                this.edit_contract_step = 6;
                return;
            }
        } else if (this.edit_contract_step == 9) {
            this.addEditBreakDown();
        }
        // 4 is final step and 5 is for retry
        if (this.edit_contract_step == 6 || this.edit_contract_step == 7) {
            //cutomer payment
            if (this.edit_contract_data['newFinanceDetails'].advance_interest_amount > this.edit_contract_data['oldFinanceDetails'].advance_interest_amount) {
                if (this.payment_option.paymentType == 1) {
                    //customer default card
                    if (this.selected_option == 1) {
                        this.goToEditContract('patient_old_card', this.edit_contract_data.selected_card);
                    }
                    //customer new card
                    if (this.selected_option == 4) {
                        this.goToEditContract('patient_new_card', this.editContractStripeData.token.id);
                    }
                    //customer default bank
                    if (this.selected_option == 5) {
                        this.goToEditContract('patient_old_bank', null);
                    }
                }
                //business payment
                if (this.payment_option.paymentType == 2) {
                    //business default bank
                    if (this.selected_option == 3) {
                        this.goToEditContract('doctor_bank', null);
                    }
                    //business new card
                    if (this.selected_option == 2) {
                        this.goToEditContract('doctor_new_card', this.editContractStripeData.token.id);
                    }

                }
            } else {
                this.goToEditContract(null, null);
            }
        }

    }
    CalculateNewRecurringAmount = function () {
        if (!this.edit_contract_data.tenure) {
            this.edit_contract_data.new_recurring_amount = null;
            return;
        }
        let matched_data = this.plan_array.filter(plan => this.edit_contract_data.tenure == plan.month);
        if (matched_data && matched_data.length > 0) {
            this.edit_contract_data.new_recurring_amount = matched_data[0].new_recurring_amount_with_fee;
            this.edit_contract_data.advance_interest_amount = matched_data[0].advance_interest_amount;
            this.contractData.new_recurring_amount = matched_data[0].recurring_amount;
            this.contractData.new_recurring_amount_with_fee = matched_data[0].new_recurring_amount_with_fee;
            this.contractData.remaining_upfront_transaction_fee = matched_data[0].remaining_upfront_transaction_fee;
            this.contractData.new_upfront_with_fee = matched_data[0].new_upfront_with_fee;
            this.contractData.net_remaining_upfront_fee = matched_data[0].net_remaining_upfront_fee;
            this.contractData.old_upfront_with_fee = matched_data[0].old_upfront_with_fee;
            this.contractData.new_interest_rate = matched_data[0].interest_rate;
            this.contractData.new_interest_rate_to_show = matched_data[0].interest_rate_to_show
        } else {
            this.edit_contract_data.new_recurring_amount = null;
        }
    }
    getNearestPlan(goal) {
        if (this.edit_contract_data.tenure) {
            return;
        }
        let nearest_rec_amount = this.plan_array.reduce(function (prev, curr) {
            return (Math.abs(curr.new_recurring_amount_with_fee - goal) < Math.abs(prev.new_recurring_amount_with_fee - goal) ? curr : prev);
        }).new_recurring_amount_with_fee;
        this.plan_array.forEach(item => {
            if (item.new_recurring_amount_with_fee == nearest_rec_amount) {
                this.edit_contract_data.tenure = item.month;
                this.edit_contract_data.advance_interest_amount = item.advance_interest_amount;
                this.edit_contract_data.new_recurring_amount = nearest_rec_amount;
                this.contractData.new_recurring_amount = item.recurring_amount;
                this.contractData.new_recurring_amount_with_fee = item.new_recurring_amount_with_fee;
                this.contractData.remaining_upfront_transaction_fee = item.remaining_upfront_transaction_fee;
                this.contractData.new_upfront_with_fee = item.new_upfront_with_fee;
                this.contractData.net_remaining_upfront_fee = item.net_remaining_upfront_fee;
                this.contractData.old_upfront_with_fee = item.old_upfront_with_fee;
                this.contractData.new_interest_rate = item.interest_rate;
                this.contractData.new_interest_rate_to_show = item.interest_rate_to_show
            }
        })
    }
    setEditContractData(data) {
        this.payment_option = {};
        this.contractData = data.send_data;
        this.edit_contract_data.minimum_amount = this.contractData.financeSettings.minimum_amount || 0;
        this.edit_contract_data.maximum_amount = this.contractData.financeSettings.maximum_amount || 1000000;
        this.edit_contract_data.minimum_tenure = this.contractData.financeSettings.minimum_tenure || 1;
        this.edit_contract_data.maximum_tenure = this.contractData.financeSettings.maximum_tenure || 99;
        setTimeout(() => {
            this.mainService.stripe_element.mount('#' + 'edit_contract');
        }, 1000);

        //Remove bank form bank array
        this.changePaymentDateCardList = this.contractData.payment_sources.filter((item, index) => {
            return item.payment_source !== "Bank"
        });
        let default_card = this.changePaymentDateCardList.filter(card => card.source_id == this.contractData.source_id);
        if (default_card && default_card[0]) {
            this.selPaymentCard(default_card[0]);
        }
    }
    goToEditContract(payment_type, stripe_token) {
        if (!this.edit_contract_data.notes || !this.edit_contract_data.notes.trim()) {
            this.mainService.customPopups('Please enter a valid reason.', 2);
            return;
        }
        if (!this.edit_contract_data.terms) {
            this.mainService.customPopups('Please accept Terms & Conditions.', 2);
            return;
        }
        var payment_mode = this.payment_option.paymentType || 0;
        if (payment_type == 'doctor_bank') {
            payment_mode = 3;
        }
        var params = {
            access_token: localStorage.getItem('token'),
            pf_id: this.contractData.pf_id,
            treatment_amount: this.edit_contract_data.treatment_amount,
            number_of_payments: this.edit_contract_data.tenure,
            recurring_amount: this.contractData.new_recurring_amount,
            notes: this.edit_contract_data.notes.trim(),
            payment_mode: payment_mode, //1 from patient's card 2 from doctor's card 3 from doctor's stripe
            source_id: this.contractData.source_id_new ? this.contractData.source_id_new : this.contractData.source_id,
            stripe_token: 0
        };

        if (params.payment_mode == 1 || params.payment_mode == 2) {
            if (payment_type == 'patient_new_card' || payment_type == 'doctor_new_card') {
                params.stripe_token = stripe_token;
                delete params.source_id;
            } else {
                // delete params.source_id;
                delete params.stripe_token;
            }

        }
        if (params.payment_mode == 3) {
            delete params.source_id;
            delete params.stripe_token;
        }
        if (payment_type == 'patient_old_card') {
            params.source_id = stripe_token;
        }
        if (payment_type == 'patient_old_bank') {
            params.payment_mode = 4;
            params.source_id = this.contractData.plaidAccount && this.contractData.plaidAccount[0] && this.contractData.plaidAccount[0].source_id ? this.contractData.plaidAccount[0].source_id : 0;
        }
        this.mainService.api(params, 'edit_financing_details_doctor', true)
            .subscribe((data: any) => {
                this.editContractResult = data;
                if (data.is_error == 0) {
                    let services = this.contractData.service_record ? JSON.parse(JSON.stringify(this.contractData.service_record)) : [];
                    if (services && services.length > 0 && this.edit_contract_data.treatment_amount != this.contractData.treatment_amount && params.payment_mode != 4) {
                        this.contractData.treatment_amount = this.edit_contract_data.treatment_amount;
                        this.data.send_data.service_cost = this.contractData.treatment_amount
                        this.contract_id = this.contractData.contract_id;
                        this.serviceBreakDown = this.contractData.service_record;
                        this.totalServAmt = this.edit_contract_data.treatment_amount;
                        this.edit_contract_step = 9;
                    } else {
                        this.edit_contract_step = 7;
                    }
                    this.send_email = this.contractData.patient_email;
                    this.send_phone = this.contractData.patient_mobile && this.contractData.patient_mobile.split('-').length ? this.contractData.patient_mobile.split('-')[1] : this.contractData.patient_mobile;
                }
                if (data.is_error == 1) {
                    this.edit_contract_step = 7;
                    if (data.override_text) {
                        if (data.override_text.indexOf('You cannot use a Stripe token more than once') >= 0) {
                            this.editContractResult.override_text = "Your card has been declined";
                        } else {
                        }
                    } else {
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }
    getEditFinanceCompareV2() {
        this.edit_contract_data.oldFinanceDetails = {
            "interest_rate": this.contractData.interest_rate_to_show || this.contractData.interest_rate,
            "interest_rate_to_show": this.contractData.interest_rate_to_show || this.contractData.interest_rate,
            "number_of_payments": this.contractData.number_of_payments,
            "treatment_amount": this.contractData.treatment_amount,
            "financed_amount": this.contractData.financed_amount,
            "downpayment_amount": this.contractData.downpayment_amount,
            "recurring_amount": this.contractData.recurring_amount,
            "remaining_payments": this.contractData.remaining_payments,
            "advance_interest_amount": this.contractData.advance_interest_amount,
            "recurring_extra_amount": this.contractData.recurring_extra_amount,
            "recurring_extra_percent": this.contractData.recurring_extra_percent,
            "threshold_amount": this.contractData.threshold_amount,
            "threshold_recurring_extra_amount": this.contractData.threshold_recurring_extra_amount,
            "threshold_recurring_extra_percent": this.contractData.threshold_recurring_extra_percent
        }
        this.edit_contract_data.newFinanceDetails = {
            "interest_rate": this.contractData.new_interest_rate,
            "interest_rate_to_show": this.contractData.new_interest_rate_to_show,
            "number_of_payments": this.edit_contract_data.tenure,
            "treatment_amount": this.edit_contract_data.treatment_amount,
            "financed_amount": this.edit_contract_data.treatment_amount - this.contractData.downpayment_amount,
            "downpayment_amount": this.contractData.downpayment_amount,
            "recurring_amount": this.edit_contract_data.new_recurring_amount,
            "remaining_payments": this.edit_contract_data.tenure - (this.contractData.number_of_payments - this.contractData.remaining_payments),
            "advance_interest_amount": this.edit_contract_data.advance_interest_amount,
            "recurring_extra_amount": this.contractData.recurring_extra_amount,
            "recurring_extra_percent": this.contractData.recurring_extra_percent,
            "threshold_amount": this.contractData.threshold_amount,
            "threshold_recurring_extra_amount": this.contractData.threshold_recurring_extra_amount,
            "threshold_recurring_extra_percent": this.contractData.threshold_recurring_extra_percent
        }
        if (!this.edit_contract_data.newFinanceDetails.advance_interest_amount) {
            this.edit_contract_data.newFinanceDetails.advance_interest_amount = 0;
        }
        if (!this.edit_contract_data.oldFinanceDetails.advance_interest_amount) {
            this.edit_contract_data.oldFinanceDetails.advance_interest_amount = 0;
        }
        this.edit_contract_step = 4;
    }
    changePaymentDateCardList: any = [];
    public setChangePaymentDateData(data) {
        this.contractData = data.send_data;
        if (this.contractData.pf_status == 3 && !this.contractData.gp_recovered) {
            return;
        }
        this.edit_recurring_step = 1;
        this.payment_stripe_data = {};
        this.selected_option = null;
        this.payment_result = {};
        this.payment_option = {};
        var date = this.data.send_data.next_payment_date;
        let max_days = 90;
        if (this.contractData.doctor_settings && this.contractData.doctor_settings[0] && this.contractData.doctor_settings[0].hasOwnProperty('extend_payment_days_doctor')) {
            max_days = this.contractData.doctor_settings[0].extend_payment_days_doctor;
        }
        this.edit_recurring_data = {
            // minDate: new Date(moment(new Date()).utc().add(1, 'd').unix() * 1000),
            // maxDate: new Date(moment(new Date()).utc().add(3, 'M').unix() * 1000),
            minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            maxDate: new Date(new Date(this.contractData.next_payment_date).setDate(new Date(this.contractData.next_payment_date).getDate() + max_days)),
            payment_date: null
        }

        //Remove bank form bank array
        this.changePaymentDateCardList = this.contractData.payment_sources.filter((item, index) => {
            return item.payment_source !== "Bank"
        });

        setTimeout(() => {
            this.mainService.stripe_element.mount('#' + 'edit_recurring');
        }, 1000);
    }

    public sendContractPdf(step) {
        let data = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            email: this.send_email,
            mobile_number: this.send_phone,
            type: 1
        };

        if (!this.send_email) {
            this.mainService.customPopups('Please enter a valid email address', 2);
            return false;
        }
        if (this.send_phone) {
            let phone = this.send_phone.replace(/-/g, '');
            if (!phone || phone.length < 9) {
                this.mainService.customPopups('Please enter valid phone number', 2);
                return false;
            }
            data.mobile_number = this.send_phone.replace(/-/g, '');
        }

        if (step == 'edit_recurring_step') {
            data.type = 2;
            data['old_recurring_date'] = moment(this.contractData.next_payment_date).format('MM/DD/yyyy');
            data['new_recurring_date'] = moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy');
        } else if (step == 'edit_contract_step') {
            data.type = 3;
            data['old_treatment_amount'] = this.edit_contract_data.oldFinanceDetails.treatment_amount.toFixed(2);
            data['new_treatment_amount'] = this.edit_contract_data.newFinanceDetails.treatment_amount.toFixed(2);
            data['old_financed_amount'] = this.edit_contract_data.oldFinanceDetails.financed_amount.toFixed(2);
            data['new_financed_amount'] = this.edit_contract_data.newFinanceDetails.financed_amount.toFixed(2);
            data['old_downpayment_amount'] = this.edit_contract_data.oldFinanceDetails.downpayment_amount.toFixed(2);
            data['new_downpayment_amount'] = this.edit_contract_data.newFinanceDetails.downpayment_amount.toFixed(2);
            data['old_interest_rate'] = this.edit_contract_data.oldFinanceDetails.interest_rate.toFixed(2);
            data['new_interest_rate'] = this.edit_contract_data.newFinanceDetails.interest_rate_to_show.toFixed(2) || this.edit_contract_data.newFinanceDetails.interest_rate.toFixed(2);
            data['old_total_payments'] = this.edit_contract_data.oldFinanceDetails.number_of_payments;
            data['new_total_payments'] = this.edit_contract_data.newFinanceDetails.number_of_payments;
            data['old_remaining_payments'] = this.edit_contract_data.oldFinanceDetails.remaining_payments;
            data['new_remaining_payments'] = this.edit_contract_data.newFinanceDetails.remaining_payments;
            data['old_recurring_amount'] = this.contractData.old_recurring_amount_with_fee.toFixed(2);
            data['new_recurring_amount'] = this.edit_contract_data.newFinanceDetails.recurring_amount.toFixed(2);
            data['old_interest_text'] = (!this.contractData.interest_rate_to_show || (this.contractData.interest_rate == this.contractData.interest_rate_to_show)) ? 'C' : 'F';
            data['new_interest_text'] = (!this.edit_contract_data.newFinanceDetails.interest_rate_to_show || (this.edit_contract_data.newFinanceDetails.interest_rate == this.edit_contract_data.newFinanceDetails.interest_rate_to_show)) ? 'C' : 'F';
            if (this.contractData.contract_type == 2 || this.contractData.contract_type == 4 || this.contractData.contract_type == 6) {
                data['old_upfront_fee'] = this.contractData.old_upfront_with_fee ? this.contractData.old_upfront_with_fee.toFixed(2) : 0;
                data['new_upfront_fee'] = this.contractData.new_upfront_with_fee ? this.contractData.new_upfront_with_fee.toFixed(2) : 0;
            }
        }
        this.mainService.api(data, 'send_contract_pdf', false)
            .subscribe((data: any) => {
                if (data && data.is_error == 0) {
                    if (step == 'cancel_contract_step') {
                        this.cancel_contract_step = 5;
                    } else if (step == 'edit_recurring_step') {
                        this.edit_recurring_step = 5;
                    } else if (step == 'edit_contract_step') {
                        this.edit_contract_step = 8;
                    }
                }
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text, data.is_error);
                    } else {
                        this.mainService.customPopups(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });

    }

    public gotoNextStepCancelContract() {
        if (this.cancel_contract_step === 1) {
            this.cancel_contract_step = 2;
        } else if (this.cancel_contract_step === 2) {
            if (!this.payment_option.paymentType) {
                return;
            }
            if (this.payment_option.paymentType == 1 && !(this.selected_option == 1 || this.selected_option == 4 || this.selected_option == 5)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 2 && !(this.selected_option == 2 || this.selected_option == 3)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.selected_option == 2 || this.selected_option == 4) {
                this.createStripeToken('cancel_contract');
            } else {
                this.cancel_contract_step = 3;
            }
        } else if (this.cancel_contract_step === 3) {
            if (this.changeReason) {
                this.cancelTheContract();
            } else {
                this.mainService.customPopups('Please mention reason.', 1);
            }
        } else if (this.cancel_contract_step === 4) {
            this.cancelTheContract();
        }
    }

    public backCancelContractStep() {
        this.cancel_contract_step = this.cancel_contract_step - 1;
    }

    public cancelTheContract() {
        var params = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            payment_mode: this.selected_option, //1 from patient's card 2 from doctor's card 3 from doctor's stripe
            stripe_token: this.payment_stripe_data && this.payment_stripe_data.token ? this.payment_stripe_data.token.id : 0,
            note: "cancel contract",
            doctor_id: this.contractData.doctor_id
        };
        if (this.selected_option == 1 || this.selected_option == 3) {
            delete params.stripe_token;
        }
        if (params.payment_mode == 4) {
            params.payment_mode = 1;
        }
        if (this.selected_option == 5) {
            params.payment_mode = 4;
            // params.source_id = this.contractData.plaidAccount && this.contractData.plaidAccount[0] && this.contractData.plaidAccount[0].source_id ? this.contractData.plaidAccount[0].source_id : 0;
        }

        this.mainService.api(params, 'charge_and_cancel_contract', false)
            .subscribe((data: any) => {
                this.cancel_contract_step = 4;
                this.payment_result = data;
                if (data && data.is_error == 0) {
                    this.send_email = this.contractData.patient_email;
                    this.send_phone = this.contractData.patient_mobile && this.contractData.patient_mobile.split('-').length ? this.contractData.patient_mobile.split('-')[1] : this.contractData.patient_mobile;
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        if (data.override_text.indexOf('You cannot use a Stripe token more than once') >= 0) {
                            this.payment_result.override_text = "Your card has been declined";
                        }
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    public createStripeToken(type) {
        if (!this.payment_option.cardName || this.payment_option.cardName.trim().length == 0) {
            this.mainService.customPopups('Please enter Cardholder name', 2);
            return false;
        }
        if (this.payment_option.cardName.trim().length > 100) {
            this.mainService.customPopups('Cardholder name cannot contain more than 100 characters', 2);
            return false;
        }
        this.loader = true;
        const data = {
            name: this.payment_option.cardName
        };
        this.mainService.stripe.createToken(this.mainService.stripe_element, data).then(response => {
            if (response && response.token && response.token.id) {
                this.payment_stripe_data = response;
                if (type == 'cancel_contract') {
                    this.cancel_contract_step = this.cancel_contract_step + 1;
                }
                if (type == 'edit_recurring') {
                    this.edit_recurring_step = this.edit_recurring_step + 1;
                }
                if (type == 'edit_contract') {
                    this.edit_contract_step = this.edit_contract_step + 1;
                }
            } else {
                this.loader = false;
                this.mainService.customPopups(response.error.message, 1);
            }
        });

    }
    public backRecurringDateStep() {
        this.edit_recurring_step = this.edit_recurring_step - 1;
        if (this.edit_recurring_step == 2 && this.edit_recurring_data.total_rec_amount == 0) {
            this.edit_recurring_step = this.edit_recurring_step - 1;
        }
        this.changePaymentDateCard = this.contractData.payment_sources[0];
    }

    public editRecDate() {
        var params = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            payment_mode: this.selected_option, //1 from patient's card 2 from doctor's card 3 from doctor's stripe
            stripe_token: this.payment_stripe_data && this.payment_stripe_data.token && this.payment_stripe_data.token.id ? this.payment_stripe_data.token.id : this.payment_stripe_data && this.payment_stripe_data.id ? this.payment_stripe_data.id : 0,
            note: "change payment date",
            doctor_id: this.contractData.doctor_id,
            pf_id: this.contractData.pf_id,
            source_id: this.changePaymentDateCard ? this.changePaymentDateCard.source_id : '',
            next_payment_date: moment(this.edit_recurring_data.payment_date).format('YYYY-MM-DD'),
            amount: this.edit_recurring_data.edit_recurring_amount ? this.edit_recurring_data.edit_recurring_amount : 0,
            late_fee: (25 * this.contractData.missing_payments)
        };
        if (this.selected_option == 1 || this.selected_option == 3) {
            delete params.stripe_token;
        }
        if (params.payment_mode == 4) {
            params.payment_mode = 1;
            delete params.source_id;
        }
        if (params.payment_mode == 2 || params.payment_mode == 3) {
            delete params.source_id;
        }
        if (this.selected_option == 5) {
            params.payment_mode = 4;
            params.source_id = this.contractData.plaidAccount && this.contractData.plaidAccount[0] && this.contractData.plaidAccount[0].source_id ? this.contractData.plaidAccount[0].source_id : 0;
        }
        this.mainService.api(params, 'edit_contract_recurring_date', false)
            .subscribe((data: any) => {
                this.edit_recurring_step = 4;
                this.payment_result = data;
                if (data && data.is_error == 0) {
                    this.send_email = this.contractData.patient_email;
                    this.send_phone = this.contractData.patient_mobile && this.contractData.patient_mobile.split('-').length ? this.contractData.patient_mobile.split('-')[1] : this.contractData.patient_mobile;
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        if (data.override_text.indexOf('You cannot use a Stripe token more than once') >= 0) {
                            this.payment_result.override_text = "Your card has been declined";
                        }
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }
    public nextRecurringStep() {
        if (this.edit_recurring_step === 1) {
            var next_payment_date = moment(this.edit_recurring_data.payment_date).format('YYYY-MM-DD');
            var minDate = new Date(this.edit_recurring_data.minDate).setHours(0, 0, 0, 0);
            var maxDate = new Date(this.edit_recurring_data.maxDate).setHours(0, 0, 0, 0);
            var selDate = new Date(this.edit_recurring_data.payment_date).setHours(0, 0, 0, 0);
            if (selDate < minDate || selDate > maxDate) {
                this.mainService.customPopups('Please select new recurring date.', 1);
                return false;
            }

            this.edit_recurring_data.newRecurringDate = moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy');
            if (!next_payment_date || next_payment_date == '' || next_payment_date == 'Invalid date') {
                this.mainService.customPopups('Please select new recurring date', 1);
                return false;
            }

            if (moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy') == this.contractData.next_payment_date) {
                this.mainService.customPopups('Please select new recurring date', 1);
                return false;
            }
            if (moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy') != this.contractData.next_payment_date) {
                let data = {
                    access_token: localStorage.getItem('token'),
                    contract_id: this.contractData.contract_id,
                    new_recurring_date: moment(this.edit_recurring_data.payment_date).format('YYYY-MM-DD')
                };
                this.mainService.api(data, 'check_edit_recurring_date_amount', false)
                    .subscribe((data: any) => {
                        if (data.is_error == 0) {
                            this.edit_recurring_data.edit_recurring_amount = data.amount || 0;
                            this.edit_recurring_data.total_rec_amount = parseFloat((this.edit_recurring_data.edit_recurring_amount + (25 * this.contractData.missing_payments))).toFixed(2);
                            if (this.edit_recurring_data.total_rec_amount > 0) {
                                this.edit_recurring_step = this.edit_recurring_step + 1;
                            } else {
                                this.edit_recurring_step = this.edit_recurring_step + 2;
                            }
                        }
                    }, (error: any) => {
                        console.log(error);
                    });
            }
            // return false;
        } else if (this.edit_recurring_step === 2) {
            if (!this.payment_option.paymentType) {
                return;
            }
            if (this.payment_option.paymentType == 1 && !(this.selected_option == 1 || this.selected_option == 4 || this.selected_option == 5)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 2 && !(this.selected_option == 2 || this.selected_option == 3)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.selected_option == 2 || this.selected_option == 4) {
                this.createStripeToken('edit_recurring');
            } else {
                this.edit_recurring_step = 3;
            }
        } else if (this.edit_recurring_step === 3) {
            if (this.changeReason) {
                this.editRecDate();
            } else {
                this.mainService.customPopups('Please mention reason.', 1);
            }
        } else if (this.edit_recurring_step === 4) {
            this.editRecDate();
        }
    }
    goToClaim(missingPayment) {
        if (this.contractData.ind_is_guaranteed != '1') {
            this.mainService.customPopups('This contract is non-insured. For more information, please contact us at (833) 336-3348 or support@denefits.com.', 1);
            return false;
        }
        if (this.contractData.max_claim_amount == 0 && this.contractData.settlement_amount != 0) {
            this.mainService.customPopups('This contract is settled and you are already paid for the allowed amount.', 1);
            return false;
        }
        if (this.contractData && this.contractData.claimInfo.length > 0) {
            let dialogRef = this.dialog.open(SimpleDialogComponent, {
                width: '610px',
                panelClass: 'simpleDialog',
                data: {
                    type: 11
                }
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.claimPayment(missingPayment)
                }
            });
            return false;
        } else {
            return;
        }
    };

    claimPayment(mPayment) {
        let params = {
            access_token: localStorage.getItem('token'),
            missing_payment_id: [mPayment.missing_payment_id]
        }
        this.mainService.api(params, 'claim_payment', false)
            .subscribe((data: any) => {
                if (data.is_error == 1) {
                    this.mainService.customPopups(data.override_text || data.err, 1);
                } else {
                    this.mainService.customPopups('Payment claimed successfully', 0);
                    this.confirmAction();
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    goTo(path) {
        this.dialogRef.close();
        setTimeout(() => {
            this.router.navigate([path]);
        }, 300);
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            if (this.emailCtrl.errors && this.emailCtrl.errors.pattern) {
                this.mainService.customPopups('Please enter a valid email', 1);
            } else {
                let index = this.emails.indexOf(value.trim());
                if (index === -1) {
                    this.emails.push(value.trim());
                }
                if (input) {
                    input.value = '';
                }
                this.emailCtrl.setValue(null);
            }
        }
    }

    remove(email: string): void {
        const index = this.emails.indexOf(email);
        if (index >= 0) {
            this.emails.splice(index, 1);
        }
    }

    sendPaymentEmail() {
        if (this.emails.length == 0) {
            this.mainService.customPopups('Enter atleast one valid mail', 1);
            return;
        }
        let params = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            email_link: this.contractData.card_link,
            email_id: this.emails.join(','),
            language_preferred: this.languageSelected
        };
        this.mainService.api(params, 'send_social_email', false)
            .subscribe((data: any) => {
                if (data.is_error == 1) {
                    if (data.override_text) {
                        this.mainService.customPopups(data.override_text, 1)
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.mainService.flagPopUps(data.flag, data.is_error);
                    this.confirmAction();
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    copyPaymentLink(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        try {
            var successful = document.execCommand('copy');
            if (!successful) throw successful;
            alert('Copied Successfully!');
        } catch (err) {
            window.prompt("Copy to clipboard: Ctrl+C, Enter", val);
        }
        document.body.removeChild(selBox);
    }

    sendAppLink() {
        if (this.emailCtrl.errors) {
            this.mainService.customPopups('Please enter a valid email', 1);
            return
        }
        var customerAppFormData = {
            access_token: localStorage.getItem('token'),
            contract_id: this.data.send_data.contract_id,
            patient_email: this.emailCtrl.value,
        }
        this.mainService.api(customerAppFormData, 'send_customer_app_link', false)
            .subscribe((data: any) => {
                if (data.is_error == 1) {
                    if (data.override_text) {
                        this.mainService.customPopups(data.override_text, 1);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.mainService.customPopups('Customer App Links Sent Successfully!', 0);
                    this.confirmAction();
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    cardDetails: any = {};
    addCard(form: NgForm) {
        this.new_address.cardError = "";
        if (!this.new_address.checked || this.new_address.checked == undefined) {
            if (this.new_address.state == '' || this.new_address.state == undefined) {
                this.mainService.customPopups('Please fill all required fileds.', 1);
            }
        }

        if (form.valid) {
            const _this = this;
            const data = {
                name: form.value.cardholder_name
            };
            if (form.value.billing_check) {
                data['address_line1'] = this.data.send_data.new_address_1 ? this.data.send_data.new_address_1 : '';
                data['address_line2'] = this.data.send_data.new_address_2 ? this.data.send_data.new_address_2 : '';
                data['address_city'] = this.data.send_data.city ? this.data.send_data.city : '';
                data['address_state'] = this.data.send_data.state ? this.data.send_data.state : '';
                data['address_zip'] = this.data.send_data.zip_code ? String(this.data.send_data.zip_code) : '';
                data['address_country'] = this.data.send_data.country_code ? this.data.send_data.country_code : 'US';
            } else {
                data['address_line1'] = this.new_address.new_address_1;
                data['address_city'] = this.new_address.city;
                data['address_state'] = this.new_address.state;
                data['address_zip'] = String(this.new_address.zip_code);
                data['address_country'] = this.new_address['country_code'] || 'US';
            }
            if (!form.value.billing_check
                && !(data['address_line1'] && data['address_city'] && data['address_state'] && data['address_zip'] && data['address_country'])) {
                return;
            }
            this.loaderService.show();
            this.mainService.stripe.createToken(this.mainService.stripe_element, data).then(response => {
                this.loaderService.hide();
                if (response && response.token && response.token.id) {
                    var data = {}
                    if (this.data.type == 20) {
                        data = {
                            access_token: localStorage.getItem('token'),
                            patient_id: this.data.send_data.patient_id,
                            stripe_token: response.token.id,
                            save_card: form.value.saveDefault ? 1 : 0,
                            payment_source_type: 2,
                        }
                    } else {
                        data = {
                            access_token: localStorage.getItem('token'),
                            contract_id: this.data.send_data.contract_id,
                            pf_id: this.data.send_data.pf_id,
                            patient_id: this.data.send_data.patient_id,
                            stripe_token: response.token.id,
                            save_card: form.value.saveDefault ? 1 : 0,
                            payment_source_type: 2,
                        }
                    }

                    // save_card
                    if (this.data.title == 'Add Backup Card' || this.data.title == 'Add Card' || this.data.title == 'Select/Add Card for recurring payments') {
                        this.dialogRef.close({
                            'result': 1,
                            'card_response': response,
                        });
                        return false;
                    }
                    this.mainService.api(data, 'add_payment_source', true)
                        .subscribe((data: any) => {
                            if (data.is_error == 1) {
                                if (data.override_text) {
                                    this.mainService.customPopups(data.override_text, 1);
                                } else {
                                    this.mainService.customPopups(data.err, data.is_error);
                                }
                            } else {
                                this.responseSubmitted = true;
                                this.confirmAction();
                            }
                        }, (error: any) => {
                            console.log(error);
                        });
                } else {
                    _this.zone.run(_ => {
                        _this.new_address.cardError = response.error.message;
                    });
                }
            });
        }
    }



    addCardSubmit() {
        if(!this.addCardForm.invalid){
            if(this.zip_data && this.zip_data.city_id){
            }else{
                if(this.showAddressField){
                    if(this.zip_data && this.zip_data.city){
                        this.zip_data['city']=this.addCardForm.value && this.addCardForm.value.city
                        this.zipcodeUpdate(this.zip_data)
                    }else{
                        this.zip_data['city']=(this.addCardForm.value && this.addCardForm.value.city) || ""
                        this.zipcodeUpdate(this.zip_data)
                    }
                }
            }
        }
        this.iscardSubmitted = true;
        const _this = this;
        const data = {
            name: this.addCardForm.value.cardholder_name
        };

        if (this.addCardForm.value.checked) {
            data['address_line1'] = this.data.send_data.new_address_1 ? this.data.send_data.new_address_1 : '';
            data['address_line2'] = this.data.send_data.new_address_2 ? this.data.send_data.new_address_2 : '';
            data['address_city'] = this.data.send_data.city ? this.data.send_data.city : '';
            data['address_state'] = this.data.send_data.state ? this.data.send_data.state : '';
            data['address_zip'] = this.data.send_data.zip_code ? String(this.data.send_data.zip_code) : '';
            data['address_country'] = this.data.send_data.country_code ? this.data.send_data.country_code : 'US';
        } else {
            // const ctrl = this.addCardForm.get('city');
            // ctrl.enable();
            data['address_line1'] = this.addCardForm.value.new_address_1;
            data['address_line2'] = this.addCardForm.value.new_address_2;
            data['address_city'] = this.addCardForm.value.city;
            data['address_state'] = this.zip_data && this.zip_data.state_name;
            data['address_zip'] = this.addCardForm.value.zip_code;
            data['address_country'] = this.addCardForm.value.country_code || 'US';
        }
        if (!this.addCardForm.value.checked && !(data['address_line1'] && data['address_city'] && data['address_state'] && data['address_zip'] && data['address_country'])) {
            return;
        }
        if (!data.name) {
            return false;
        }

        setTimeout(() => {
            this.loaderService.show();
            this.mainService.stripe.createToken(this.mainService.stripe_element, data).then(response => {
                this.loaderService.hide();
                if (response && response.token && response.token.id) {
                    var data = {}
                    this.iscardSubmitted = false;
                    if (this.data.type == 20) {
                        data = {
                            access_token: localStorage.getItem('token'),
                            patient_id: this.data.send_data.patient_id,
                            stripe_token: response.token.id,
                            save_card: this.addCardForm.value.saveDefault ? 1 : 0,
                            payment_source_type: 2,
                        }
                    } else if (this.data.type == 51 || this.data.type == 603 || this.data.type == 604) {
                        data = {
                            access_token: localStorage.getItem('token'),
                            stripe_token: response.token.id,
                            save_card: this.data.send_data.showDefault ? (this.addCardForm.value.saveDefault ? 1 : 0) : 0,
                            payment_source_type: 2,
                        }
                    } else {
                        data = {
                            access_token: localStorage.getItem('token'),
                            contract_id: this.data.send_data.contract_id,
                            pf_id: this.data.send_data.pf_id,
                            patient_id: this.data.send_data.patient_id,
                            stripe_token: response.token.id,
                            save_card: this.addCardForm.value.saveDefault ? 1 : 0,
                            payment_source_type: 2,
                        }
                    }

                    // save_card
                    if (this.data.title == 'Add Backup Card' || this.data.title == 'Add Card' || this.data.title == 'Select/Add Card for recurring payments' || this.data.title == 'Select/Add Card for subscription') {
                        this.dialogRef.close({
                            'result': 1,
                            'card_response': response,
                        });
                        return false;
                    }

                    this.mainService.api(data, 'add_payment_source', true)
                        .subscribe((data: any) => {
                            if (data.is_error == 1) {
                                if (data.override_text) {
                                    this.mainService.customPopups(data.override_text, 1);
                                } else {
                                    this.mainService.customPopups(data.err, data.is_error);
                                }
                            } else {
                                this.responseSubmitted = true;
                                this.confirmAction();
                            }
                        }, (error: any) => {
                            console.log(error);
                        });

                } else {
                    _this.zone.run(_ => {
                        _this.new_address.cardError = response.error.message;
                    });
                }
            });
        }, 1500);
    }

    zipObj: any = {};
    addCardSubmitV2() {
        if (!this.addCardForm.invalid) {
            if (this.zipObj && this.zipObj.city_id) {
            } else {
                if (this.showAddressField) {
                    if (this.zipObj && this.zipObj.city) {
                        this.zipObj['city'] = this.addCardForm.value && this.addCardForm.value.city
                        this.zipcodeUpdate(this.zipObj)
                    } else {
                        this.zipObj['city'] = (this.addCardForm.value && this.addCardForm.value.city) || ""
                        this.zipcodeUpdate(this.zipObj)
                    }
                }
            }
        }
        this.iscardSubmitted = true;
        const _this = this;
        if (!this.addCardForm.value.checked && !(this.addCardForm.value['new_address_1'] && this.addCardForm.value['city'] && this.addCardForm.controls.state.value && this.addCardForm.value['zip_code'] && this.addCardForm.value['country'])) {
            return;
        }
        if (!this.addCardForm.value.cardholder_name) {
            return false;
        }

        setTimeout(async () => {
            this.loaderService.show();
            let response = await this.stripe.stripe.confirmCardSetup(
                this.stripe.setup_intent_secret.setup_intent_secret,
                {
                    payment_method: {
                        card: this.stripe.paymentElement,
                        billing_details: {
                            name: this.addCardForm.value.cardholder_name,
                            address: {
                                line1: this.addCardForm.value.new_address_1,
                                line2: this.addCardForm.value.new_address_2,
                                city: this.addCardForm.value.city || '',
                                state: this.addCardForm.controls.state.value || '',
                                postal_code: this.addCardForm.value.zip_code,
                                country: this.addCardForm.value.country_code || 'US',
                            }
                        },
                    },
                }
            );

            if (response.error) {
                _this.zone.run(_ => {
                    _this.new_address.cardError = response.error.message;
                });
                this.mainService.customPopups(response.error.message, 1)
                this.loaderService.hide();
                return
            }
            if (response.setupIntent && response.setupIntent.status === "succeeded") {
                let data = {};
                if (this.data.type == 20) {
                    data = {
                        access_token: localStorage.getItem('token'),
                        seti_id: response.setupIntent.id,
                        patient_id: this.data.send_data.patient_id,
                        stripe_token: response.setupIntent.payment_method,
                        save_card: this.addCardForm.value.saveDefault ? 1 : 0,
                        payment_source_type: 2,
                    }
                } else if (this.data.type == 51 || this.data.type == 603 || this.data.type == 604) {
                    data = {
                        access_token: localStorage.getItem('token'),
                        seti_id: response.setupIntent.id,
                        stripe_token: response.setupIntent.payment_method,
                        save_card: this.data.send_data.showDefault ? (this.addCardForm.value.saveDefault ? 1 : 0) : 0,
                        payment_source_type: 2,
                    }
                } else {
                    data = {
                        access_token: localStorage.getItem('token'),
                        seti_id: response.setupIntent.id,
                        contract_id: this.data.send_data.contract_id,
                        pf_id: this.data.send_data.pf_id,
                        patient_id: this.data.send_data.patient_id,
                        stripe_token: response.setupIntent.payment_method,
                        save_card: this.addCardForm.value.saveDefault ? 1 : 0,
                        payment_source_type: 2,
                    }
                }
                // save_card
                if (this.data.title == 'Add Backup Card' || this.data.title == 'Add Card' || this.data.title == 'Select/Add Card for recurring payments' || this.data.title == 'Select/Add Card for subscription') {
                    this.dialogRef.close({
                        'result': 1,
                        'card_response': response,
                    });
                    return false;
                }

                this.mainService.api(data, 'add_payment_source', true)
                    .subscribe((data: any) => {
                        if (data.is_error == 1) {
                            if (data.override_text) {
                                this.mainService.customPopups(data.override_text, 1);
                            } else {
                                this.mainService.customPopups(data.err, data.is_error);
                            }
                        } else {
                            this.responseSubmitted = true;
                            this.confirmAction();
                        }
                    }, (error: any) => {
                        console.log(error);
                    });
                this.loaderService.hide();
            }
        }, 1500);
    }

    changeAddres() {
        if (this.addCardForm.controls.checked) {
            this.addCardForm.controls.zip_code.setValue('');
            this.addCardForm.controls.city.setValue('');
            this.addCardForm.controls.state.setValue('');
            this.addCardForm.controls.country_code.setValue('');
        }
    }

    // added citi id if not there
    zipcodeUpdate(data1) {
        if (data1 && data1.city_id) {
        } else {
            var common_data:any={}
            common_data['user_data']={
                addressObj:data1
            }
            this.mainService.api(common_data, `add_address`, false).subscribe(response => {
                if (!response.is_error) {
                    if (response && response.data) {
                        this.getZipselected(response && response.data && response.data.user_data && response.data.user_data[0])
                    }
                } else {
                    console.log(response.override_text);
                }
            });
        }
    }

    zip_data:any
    getZipselected(zipObj: any) {

        // if(zipObj && zipObj.city_id){
        // this.addCardForm.get('city').disable()
        // }else{
        // this.addCardForm && this.addCardForm.get('city') && this.addCardForm.get('city').enable()
        // }
        try {
            if (zipObj == '') {
                this.zipCode=''
                this.addCardForm.controls.zip_code.setValue('');
                this.addCardForm.controls.zip_code.markAsTouched();
                this.addCardForm.controls.city.setValue('');
                this.addCardForm.controls.city.markAsTouched();
                this.addCardForm.controls.state.setValue('');
                this.addCardForm.controls.state.markAsTouched();
                this.addCardForm.controls.country_code.setValue('');
                this.addCardForm.controls.country_code.markAsTouched();
            }
            else {
                this.zip_data=zipObj;
                this.zipCode = zipObj.zip;
                this.addCardForm.controls.zip_code.setValue(zipObj.zip);
                this.addCardForm.controls.city.setValue(zipObj.city);
                this.addCardForm.controls.country_code.setValue(zipObj.country_code);
                this.addCardForm.controls.state.setValue(zipObj.state_name);
                this.addCardForm.markAsDirty()
            }
        } catch (err) {
            console.log(err)
        }
    }
    changeEnvironment() {
        localStorage.setItem('environment', this.environment);
        switch (this.environment) {
            case 't1':
                environment.baseUrl = 'https://api.denefits.com/business/';
                break;
            case 't2':
                environment.baseUrl = 'https://api.denefits.com/business2/';
                break;
            case 't3':
                environment.baseUrl = 'https://api.denefits.com/business3/';
                break;
            case 't4':
                environment.baseUrl = 'https://api.denefits.com/business4/';
                break;
            case 't5':
                environment.baseUrl = 'https://api.denefits.com/business5/';
                break;
            case 't6':
                environment.baseUrl = 'https://api.denefits.com/business6/';
                break;
            case 'd1':
                environment.baseUrl = 'https://demoapi.denefits.com/business/';
                break;
            default:
                this.environment = 't1'
                environment.baseUrl = 'https://api.denefits.com/business/';
                break;
        }
        localStorage.setItem('baseUrl', environment.baseUrl);
        this.confirmAction();
    }
    cancelChangeEnv() {
        if (localStorage.getItem('environment')) {
            this.environment = localStorage.getItem('environment');
        }
    }

    /* No-Fee - New Custom Plan */
    enterTermVal: string;
    termError = false;
    errorMessage = '';

    enterRecurringAmt: string;
    recurringAmtError = false;

    enterNumberOnly(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    isCustomPlanAddDisabled(): boolean {
        if (this.enterTermVal) {
            return false;
        }
        if (this.enterRecurringAmt === '' || this.enterRecurringAmt === null || this.enterRecurringAmt === undefined) {
            return true;
        }
        const recurringAmount = Number(this.enterRecurringAmt);
        return isNaN(recurringAmount) || recurringAmount <= 0;
    }

    validateEnteredAmt() {
        let di_start_month = '5'
        this.recurringAmtError = false;
        this.termError = false;
        var data = this.data.send_data.data;
        let plans;
        if(this.data.send_data.contract_type != 6){
           plans = this.data.send_data.array_data.filter((item) => {
                return item.show == true;
            }).map((item_1) => {
                return this.enterTermVal ? item_1.month.toString() : item_1.recurring_amount;
            });
        } else{
            plans = this.data.send_data.array_data.filter((item) => {
                return item.show == true;
            }).map((item_1) => {
                return this.enterTermVal ? item_1.month.toString() : item_1.next_recurring_amount;
            });
        }

        if(this.enterTermVal && !data[0].includes(Number(this.enterTermVal))){
            this.termError = true;
            this.errorMessage = 'Sorry No Plan Available';
            return;
        }

        if (this.enterTermVal && plans.includes(this.enterTermVal)) {
            this.termError = true;
            this.errorMessage =  "Payment Plan already exists";
            return
        }

        if (this.enterTermVal) {
            if (this.enterTermVal > data[0][data[0].length - 1]) {
                this.termError = true;
                this.errorMessage = 'Term value cannot be greater than' + data[0][data[0].length - 1] + '';
                return
            } else if (this.enterTermVal < data[0][0]) {
                this.termError = true;
                this.errorMessage = 'Term value cannot be less than 6';
                return
            } else {
                this.termError = false;
                this.errorMessage = '';
                this.dialogRef.close({
                    'term_val': this.enterTermVal,
                    'length_array': this.data.send_data.array_data.length + 1
                });
                return;
            }
        }

        const hasRecurringInput = this.enterRecurringAmt !== '' &&
            this.enterRecurringAmt !== null &&
            this.enterRecurringAmt !== undefined;
        if (!hasRecurringInput) {
            return;
        }

        const recurringAmount = Number(this.enterRecurringAmt);
        if (isNaN(recurringAmount) || recurringAmount <= 0) {
            this.recurringAmtError = true;
            this.errorMessage = 'Recurring amount must be greater than <span class="notranslate ms-2">$0</span>';
            return;
        }

        if (plans.includes(recurringAmount)) {
            this.recurringAmtError = true;
            this.errorMessage =  "Payment Plan already exists";
            return
        }

        const minAmount = Number(data[1]);
        const maxAmount = Number(data[2]);
        if (recurringAmount >= minAmount && recurringAmount <= maxAmount) {
            this.recurringAmtError = false;
            this.errorMessage = '';
            this.dialogRef.close({
                'recurring_amt': recurringAmount,
                'length_array': this.data.send_data.array_data.length + 1
            });
        } else {
            this.recurringAmtError = true;
            if (recurringAmount > maxAmount) {
                this.errorMessage = 'You cannot select Recurring amount greater than <span class="notranslate ms-2">$' + data[2] + '</span>';
            } else if (recurringAmount < minAmount) {
                this.errorMessage = 'You cannot select Recurring amount less than <span class="notranslate ms-2">$' + data[1] + '</span>';
            }
        }
    }

    /* /No-Fee - New Custom Plan */

    /* Divide Payment into services */
    services() {
        this.totalServAmt = this.serviceBreakDown.map(o => o.price).reduce((a, c) => { return Number(a) + Number(c) });
    };

    /* Service Breakdown */
    deleteBreakdown(deleted_index) {
        this.serviceBreakDown = this.serviceBreakDown.filter((item, index, data) => {
            return deleted_index !== index
        })
        this.services();
        this.addFocus('breakDownVal' + (this.serviceBreakDown.length - 1) + '')
    }

    addBreakdown() {
        let info = true;
        this.serviceBreakDown.map((ele) => {
            if (ele.service.length == 0 || ele.price.length == 0) {
                info = false;
            }
            else {
                info = true;
            }
        })

        if (info) {
            this.serviceBreakDown.push({
                service: '',
                price: ''
            });
        }
        else {
            this.mainService.customPopups('Please fill above field data first.', 1);
        }
        this.addFocus('breakDownText' + (this.serviceBreakDown.length - 1) + '')
    }

    /* Add Focus */
    addFocus(d) {
        setTimeout(() => {
            document.getElementById(d).focus();
        }, 200);
    }

    addEditBreakDown() {
        let abc = this.serviceBreakForm.value.items.every(item => item.service.trim().length > 0)
        let addOns = this.serviceBreakForm.value.addOns.every(item => item.service.trim().length > 0)
        if (abc && addOns) {
            let values = this.serviceBreakForm.value.items.concat(this.serviceBreakForm.value.addOns).map(obj => obj.price);

            const totalPrice = values.reduce((accumulator, currentValue) => { return accumulator + currentValue; }, 0);

            const validation = [...this.serviceBreakForm.value.items, ...this.serviceBreakForm.value.addOns].every(item => item.service && item.price >= 0);
            if (!validation) {
                this.mainService.customPopups('Price breakdown is incomplete.', 1);
                return false;
            }

            if (totalPrice != this.data.send_data.service_cost) {
                this.mainService.customPopups('Service breakdown amount does not matched with your service amount.', 1);
                return false;
            }
            let data = {
                access_token: localStorage.getItem('token'),
                contract_id: this.contract_id,
                contract_service_record: [...this.serviceBreakForm.value.items, ...this.serviceBreakForm.value.addOns]
            };
            this.mainService.api(data, 'update_contract_service_record', false)
                .subscribe((data: any) => {
                    if (!data.is_error) {
                        this.submitted = false;
                        this.mainService.customPopups("Updated successfully.", 0);
                        if (this.data.type == 48) {
                            this.edit_contract_step = 7;
                        } else {
                            this.dialogRef.close({
                                'result': 2,
                                'service_added': this.serviceBreakDown
                            });
                        }
                    } else {
                        this.mainService.customPopups(data.err, 1);
                    }
                });
        }
        else {
            this.mainService.customPopups("Please enter valid service name.", 1);
        }
    }
    /* /Divide Payment into services */

    /* Send Proposal */
    sendProposalInvalid = false;
    invalidEmailProsposal = false

    sendProposal(form: NgForm) {
        this.sendProposalInvalid = false;
        this.invalidEmailProsposal = false;
        let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        if (form.invalid) {
            this.sendProposalInvalid = true;
            let mail = form.value.user_email ? form.value.user_email : this.data.send_data.user_email;
            if (!EMAIL_REGEXP.test(mail)) {
                this.invalidEmailProsposal = true;
            }
            return false;
        }

        if((this.data.send_data.user_phone == this.phoneCovertor(this.userInfo[0].doctor_mobile)) || (this.data.send_data.user_phone == this.phoneCovertor(this.userInfo[0].practice_mobile))){
            this.mainService.customPopups('Customer Phone Number Cannot be same as Business Phone.', 1);
            return false;
        }
        this.sendProposalInvalid = false;
        if (form.value.user_email == this.data.send_data.doctor_email) {
            this.mainService.customPopups('You cannot use this email address as this is associated with your account.', 1);
            return false;
        } else {
            let data = {
                access_token: localStorage.getItem('token'),
                split_req_id: this.data.send_data.split_req_id,
                downpayment_amount: this.data && this.data.downpaymentCost && this.data.downpaymentCost,
                treatment_amount: this.data && this.data.send_data && this.data.send_data.treatment_amount && this.data.send_data.treatment_amount,
                interest_rate: this.data && this.data.send_data && this.data.send_data.interest_rate && this.data.send_data.interest_rate,
                contract_type: this.data && this.data.send_data && this.data.send_data.contract_type && this.data.send_data.contract_type,
                months_array: this.checkboxed.map((item, index) => {
                    if (typeof (item) == 'object') {
                        return item.month.toString()
                    }
                    else {
                        return this.data.allContracts[item].month.toString();
                    }
                }),
                doctor_id: this.data.send_data.doctor_id,
                fixed_flat_fee: this.data['enrollment_fee'],
                patient_email: form.value.user_email || this.data.send_data.user_email,
                patient_first_name: form.value.first_name || this.data.send_data.first_name,
                patient_last_name: form.value.last_name || this.data.send_data.last_name,
                patient_mobile: form.value.user_phone || this.data.send_data.user_phone,
                start_date: '',
                end_date: '',
                language_preferred: this.languageSelected,
                pre_approval_lead_id: this.data && this.data.send_data && this.data.send_data.pre_approval_lead_id
            };
            if (this.data.send_data.serviceBreakdown && this.data.send_data.serviceBreakdown[0].price >= 0 && this.data.send_data.serviceBreakdown[0].price != '') {
                Object.assign(data, { contract_service_record: this.data.send_data.serviceBreakdown });
            }
            if (this.proposalDurationModel == 'Custom Date') {
                data.start_date = this.datepipe.transform(form.value.startDate, 'yyyy-MM-dd'),
                    data.end_date = this.datepipe.transform(form.value.endDate, 'yyyy-MM-dd')
            } else {
                data.start_date = this.datepipe.transform(this.proposalStartDate, 'yyyy-MM-dd'),
                    data.end_date = this.datepipe.transform(this.proposalEndDate, 'yyyy-MM-dd')
            }
            this.loaderService.show();
            this.mainService.api(data, this.data.send_data.split_req_id ? 'edit_split_request' : 'send_split_plans_v2', false)
                .subscribe((data: any) => {
                    if (data.is_error == 0) {
                        this.proposalSent = true;
                    } else {
                        this.proposalSent = false;
                        this.loaderService.hide();
                        if (data.override_text || data.err) {
                            this.mainService.customPopups(data.override_text || data.err, data.is_error);
                        } else {
                            this.mainService.flagPopUps(data.flag, data.is_error);
                        }
                    }
                });
        }
    }
    phoneCovertor(phonenumber) {
        if (!phonenumber) return;

        const usCountryCode = "+1-";
        const dash = "-";

        if (phonenumber.startsWith(usCountryCode)) {
          return phonenumber.substring(usCountryCode.length);
        }

        if (phonenumber.includes(dash)) {
          return phonenumber.split(dash).join('');
        }

        return phonenumber;
      }
    /* Sent Payment Link */
    sendPayLinkCusData: any = [];
    paymentLinkSent: boolean = false;
    sendPaymentLinkCustomer(form) {
        if (form.invalid) {
            return false;
        }
        if (form.value.user_alternate_email == this.data.send_data.user_email) {
            this.mainService.customPopups('Alternate email should be other than the customer email.', 1);
            return false;
        }
        if (form.value.user_alternate_phone == form.value.user_phone) {
            this.mainService.customPopups('Alternate phone number should be other than the customer phone number.', 1);
            return false;
        }
        if (form.value.user_alternate_email && form.value.user_alternate_email == this.data.send_data.doctor_email) {
            this.mainService.customPopups('You cannot use this email address as this is associated with your account.', 1);
            return false;
        } else {
            let data = {
                access_token: localStorage.getItem('token'),
                contract_id: this.data.send_data.contract_id,
                customer_alternate_email: form.value.user_alternate_email,
                customer_alternate_mobile: form.value.user_alternate_phone,
                next_payment_date: this.data.send_data.next_payment_date,
                doctor_id: this.data.send_data.doctor_id,
            }
            if (this.data.send_data.service_breakdown[0].price >= 0 && this.data.send_data.service_breakdown[0].price != '') {
                Object.assign(data, { contract_service_record: this.data.send_data.service_breakdown });
            }
            this.sendPayLinkCusData = data;
            this.mainService.api(data, 'send_split_contract_plans', false).subscribe((data: any) => {
                if (data.is_error == 0) {
                    this.paymentLinkSent = true;
                } else {
                    this.paymentLinkSent = false;
                }
            });
        }
    }

    /* Swtich business to customer */
    hide = true;
    switchBusinessToCustomer(form) {
        if (form.invalid) {
            // this.mainService.customPopups('Enter valid password.', 1);
            this.passEror = true;
            return;
        };
        let data = {
            access_token: localStorage.getItem('token'),
            token: 1,
            profile: 'doctor',
            password: this.mainService.encryptInMD5(form.value.password),
            email: this.data.send_data.doctor_email,
            doctor_id: this.data.send_data.doctor_id
        }
        this.mainService.api(data, 'freeze_me', false).subscribe((data: any) => {
            if (data.is_error == 0) {
                this.dialogRef.close(1);
            } else {
                this.passEror = true;
                // this.mainService.customPopups('Enter valid password.', 1);
            }
        });
    }

    /* Select Card for payment */
    selectCardForPayment(d) {
        this.data.send_data.card_list.forEach(ele => {
            ele.active = false;
        });
        d.active = true;
        this.dialogRef.close({
            'result': 1,
            'selectedCard': d.last4,
            'source_id': d.source_id,
            'funding': d.funding
        });
        //this.confirmAction();
    }

    /* Select a card for Payment - Change Payment Date*/
    changePaymentDateCard: any
    selPaymentCard(d) {
        this.changePaymentDateCard = d;
    }
    incProcessLimitPpScreen: boolean = true;
    ppCardAmount;
    ppBankAmount;
    businessVerfStep = 1;
    is_auth_card_added = 0;
    incProcessLimitPp() {
        if (!this.ppCardAmount && !this.ppBankAmount) {
            this.mainService.customPopups('Please enter valid desired limit amount.', 2);
            return false;
        } if ((this.ppCardAmount == 0 && this.ppBankAmount == 0)) {
            this.mainService.customPopups('Desired card and bank amount cant' + '$0.', 2);
            return false;
        } else if (this.ppCardAmount < 0) {
            this.mainService.customPopups('Please enter valid desired card amount.', 2);
            return false;
        } else if (this.ppBankAmount < 0) {
            this.mainService.customPopups('Please enter valid desired bank amount.', 2);
            return false;
        } else if (this.ppCardAmount > 99999) {
            this.mainService.customPopups('Desired card amount should be less than $100000.', 2);
            return false;
        } else if (this.ppBankAmount > 99999) {
            this.mainService.customPopups('Desired bank amount should be less than $100000.', 2);
            return false;
        } else {
            this.incProcessLimitPpScreen = false;
        }
    }

    checkStepBusinessVer() {
        if (this.businessVerfStep == 2) {
            this.payment_option = {};
            setTimeout(() => {
                if (!this.data.send_data.acc_details.auth_card.length) {
                    this.mainService.stripe_element.mount('#' + 'pp_add_card');
                }
            }, 2000);
        }
    }



    addCardBusinessPP(form: NgForm) {
        if (form.valid) {
            this.new_address.cardError = "";
            const _this = this;
            const data = {
                name: form.value.cardholder_name
            };
            this.loaderService.show();
            this.mainService.stripe.createToken(this.mainService.stripe_element, data).then(response => {
                this.loaderService.hide();
                if (response && response.token && response.token.id) {
                    var data = {
                        access_token: localStorage.getItem('token'),
                        card_token: response.token.id,
                        doctor_id: this.data.send_data.doctor_id,
                        card_desired_amount: this.ppCardAmount ? this.ppCardAmount : 0,
                        bank_desired_amount: this.ppBankAmount ? this.ppBankAmount : 0,
                    }
                    this.mainService.api(data, 'add_business_auth_card', true)
                        .subscribe((data: any) => {
                            if (data.is_error == 0) {
                                this.confirmAction();
                                this.mainService.customPopups('Card Added Successfully.', 0);
                            }
                        }, (error: any) => {
                            console.log(error);
                        });
                } else {
                    _this.zone.run(_ => {
                        _this.new_address.cardError = response.error.message;
                    });
                }
            });
        } else {
            if (!form.value.cardholder_name) {
                this.mainService.customPopups('Please enter a cardholder name.', 1);
                return false;
            }
        }
    }

    /* Add Dcoument */
    notes: string;

    refreshDoc() {
        let data = {
            access_token: localStorage.getItem('token'),
            doctor_id: this.data.send_data.doctor_id
        };
        this.mainService.api(data, `get_business_auth_data`, false)
            .subscribe(response => {
                this.data.send_data.acc_details = response;
            });
    }

    uploadProofId(event, i) {
        var file = event;
        if (!this.data.send_data.acc_details.auth_docs[i].name || this.data.send_data.acc_details.auth_docs[i].name.trim().length == 0) {
            this.mainService.customPopups('Please enter document name.', 1);
            return false;
        }
        let allowed_file_types = ["image/png", 'application/pdf', 'image/jpeg', 'image/jpg'];
        if (file.target.files[0].size <= 0) {
            this.mainService.customPopups('Invalid file', 1);
            return false;
        }
        if (file.target.files[0].size > (10 * 1024 * 1024)) {
            this.mainService.customPopups(`File size must be less than 10MB.`, 1);
        } else if (!allowed_file_types.includes(file.target.files[0].type)) {
            this.mainService.customPopups(`File type not supported. Please upload a valid file(.pdf, .jpeg, .png).`, 1);
        } else {
            this.doc_uploaded_disabled = false;
            this.loaderService.show();
            var form = new FormData();
            form.append('access_token', localStorage.getItem('token'));
            form.append('pp_docs', file.target.files[0]);
            form.append('doctor_id', this.data.send_data.doctor_id);
            form.append('type', this.data.send_data.acc_details.auth_docs[i].type);
            if (this.data.send_data.acc_details.auth_docs && this.data.send_data.acc_details.auth_docs[i].id && this.data.send_data.acc_details.auth_docs[i].id != null) {
                form.append('doc_id', this.data.send_data.acc_details.auth_docs[i].id);
            }
            if (this.data.send_data.acc_details.auth_docs && !this.data.send_data.acc_details.auth_docs[i].id && !this.data.send_data.acc_details.auth_docs[i].type) {
                form.append('doc_name', this.data.send_data.acc_details.auth_docs[i].name);
            }
            this.mainService.uploadApi(form, 'upload_buss_docs', true)
                .subscribe((data: any) => {
                    this.loaderService.hide();
                    if (data.is_error == 0) {
                        if (this.data.send_data.acc_details.auth_docs && this.data.send_data.acc_details.auth_docs[i].id && this.data.send_data.acc_details.auth_docs[i].id != null) {
                            this.mainService.customPopups('Document Changed Sucessfully', 0);
                        } else {
                            this.mainService.customPopups('Document Uploaded Sucessfully', 0);
                        }
                        this.hide_add_more_btn = [];
                        this.refreshDoc();
                    }
                    if (data.is_error == 1) {
                        if (data.override_text) {
                            this.mainService.customPopups(data.data.override_text, 1)
                        }
                    }
                }, (error: any) => {
                    console.log(error);
                });
        }
    };

    deleteBussAuthDoc(file) {
        var data = {
            access_token: localStorage.getItem('token'),
            id: file.id,
            doctor_id: this.data.send_data.doctor_id,
        };
        this.loaderService.show();
        this.mainService.api(data, 'delete_buss_docs', true)
            .subscribe((data: any) => {
                this.loaderService.hide();
                if (data.is_error == 0) {
                    this.mainService.customPopups('Deleted successfully.', 0);
                    this.refreshDoc();
                } else {
                    if (data.override_text) {
                        this.mainService.customPopups(data.override_text, 1)
                    }
                }
            })
    };

    /* Add More Docs */
    hide_add_more_btn = [];
    addMoreDocs() {
        if (this.data.send_data.acc_details.auth_docs.length < this.data.send_data.acc_details.auth_docs_limit) {
            this.data.send_data.acc_details.auth_docs.push({
                name: '',
            });
            this.hide_add_more_btn = this.data.send_data.acc_details.auth_docs.filter(function (a) {
                return a && a.name == '';
            });
        } else {
            this.mainService.customPopups('You cannot add more than' + this.data.send_data.acc_details.auth_docs_limit + ' documents', 2);
        }
    }

    removeMoreDocs(index) {
        this.data.send_data.acc_details.auth_docs.splice(index, 1);
        this.hide_add_more_btn = [];
    }

    docRequest() {
        var data = {
            access_token: localStorage.getItem('token'),
            notes: this.notes,
            doctor_id: this.data.send_data.doctor_id,
        };
        this.loaderService.show();
        this.mainService.api(data, 'create_internal_ticket_docs', true)
            .subscribe((data: any) => {
                this.loaderService.hide();
                if (data.is_error == 0) {
                    this.confirmAction();
                    this.mainService.customPopups('Your request has been submitted.', 0);
                    this.refreshDoc();
                    let thankyouForDocUpload = this.dialog.open(SimpleDialogComponent, {
                        width: '450px',
                        disableClose: true,
                        panelClass: 'simpleDialog',
                        data: {
                            type: 36,
                            title: 'Thank you'
                        }
                    });
                }
            })
    }

    /* addBank */
    addBank() {
        this.plaidService.createLinkTokenPlaid(
            {
                token: localStorage.getItem('token'),
                type: 6,
                doctor_id: this.data.send_data.doctor_id,
                card_desired_amount: this.ppCardAmount ? this.ppCardAmount : 0,
                bank_desired_amount: this.ppBankAmount ? this.ppBankAmount : 0,
            }
        )

        this.businessVerfStep = 2
        // this.confirmAction();
    }



    /* Request Call back */
    requestCallBack(d) {
        var id = ''
        this.data.send_data.reason.forEach(element => {
            if (this.callReasonModel == element.reason) {
                id = element.id;
            }
        });
        if (!d.value.timezone) {
            this.mainService.customPopups('Please Select Reason.', 1);
            return false;
        }
        if (!d.value.name || !d.value.name.trim()) {
            this.mainService.customPopups('Please enter a valid name.', 1);
            return false;
        }
        if (!d.value.phone) {
            this.mainService.customPopups('Please Enter a valid phone number.', 1);
            return false;
        }
        let mobile = d.value.phone.replace(/[^0-9]/g, "");
        if (mobile.length < 10) {
            this.mainService.customPopups('Please Enter a valid phone number.', 1);
            return false;
        } else if (mobile == '0000000000') {
            this.mainService.customPopups('Please Enter a valid phone number.', 1);
            return false;
        }
        if (!d.value.message || !d.value.message.trim()) {
            this.mainService.customPopups('Please Enter Message.', 1);
            return false
        }
        let data = {
            access_token: localStorage.getItem('token'),
            message: d.value.message,
            enterprise_mobile: d.value.phone,
            doctor_mobile: d.value.phone,
            priority: d.value.priority,
            call_req_date: this.data.send_data.call_req_date,
            call_req_time: this.data.send_data.call_req_time,
            csr_req_tz: this.data.send_data.csr_req_tz,
            csr_req_tz_name: this.data.send_data.csr_req_tz_name,
            reason_id: id
        }
        this.mainService.api(data, 'add_csr_call_request_v2', true)
            .subscribe((data: any) => {
                if (data.is_error == 0) {
                    this.dialogRef.close(1);
                }
            });
    }

    reasonPrioritySet(d) {
        this.data.send_data.reason.forEach(element => {
            if (d == element.reason) {
                this.data.send_data.priority = element.priority;
            }
        });
    }

    /* Reset Card */
    resetCard() {
        this.data.send_data.new_source_id = this.data.send_data.source_id;
        this.data.send_data.new_secondary_source_id = this.data.send_data.secondary_source_id;
    }

    /* Chagne Contract Payment Cards */
    changePaymentPreferences() {
        if (this.data.send_data.source_id == this.data.send_data.secondary_source_id) {
            this.mainService.customPopups("Default and backup card cann't be the same.", 1)
            return;
        }
        // Default and backup cards both take the contract's recurring charges.
        const cards = this.data.send_data.cards || [];
        const defaultCard = cards.find((card: any) => card.source_id == this.data.send_data.source_id);
        const backupCard = cards.find((card: any) => card.source_id == this.data.send_data.secondary_source_id);
        if (!this.prepaidCard.check(defaultCard, 'recurring') || !this.prepaidCard.check(backupCard, 'recurring')) {
            return;
        }
        let data = {
            access_token: localStorage.getItem('token'),
            contract_id: this.data.send_data.contract_id,
            source_id: Number(this.data.send_data.source_id),
            secondary_source_id: Number(this.data.send_data.secondary_source_id)
        }
        this.mainService.api(data, 'change_payment_methods', false)
            .subscribe((data: any) => {
                if (data.is_error == 1) {
                    this.mainService.customPopups(data.err, 1);
                } else {
                    this.mainService.customPopups('Payment methods updated successfully.', 0);
                    this.dialogRef.close(1);
                }
            });
    }

    /* How to Change Payment Dates - Video */
    paymentChargeFee() {
        let finalConfirmDialogRef = this.dialog.open(SimpleDialogComponent, {
            width: '650px',
            panelClass: 'simpleDialog',
            data: {
                type: 30,
                title: 'How to Change Payment Dates'
            }
        });
    }


    /* Verfiying Customer */
    customerVerified = false;
    verifyingStep: any = {
        counter: 0,
        loader: 0
    };
    verifyingCustomer() {
        setTimeout(() => {
            this.verifyingStep.counter++;
            if (this.verifyingStep.counter <= 9) {
                this.verifyingCustomer();
                if (this.verifyingStep.counter == 9) {
                    this.customerVerified = true;
                    setTimeout(() => {
                        this.confirmAction();
                    }, 2000);
                }
            }
        }, 1000);
        this.progressBarFilled();
    }

    progressBarFilled() {
        setTimeout(() => {
            this.verifyingStep.loader++;
            this.progressBarFilled();
        }, 300);
    }
    /* PP - Add Instant Card */
    addInstantCard(form: NgForm) {
        this.new_address.cardError = "";
        if (form.valid) {
            const _this = this;
            const data = {
                name: form.value.cardholder_name
            };
            this.loaderService.show();
            this.mainService.stripe.createToken(this.mainService.stripe_element, { currency: 'usd', name: form.value.cardholder_name }).then(response => {
                this.loaderService.hide();
                if (response && response.token && response.token.id) {
                    var data = {
                        access_token: localStorage.getItem('token'),
                        card_token: response.token.id,
                        doctor_id: this.data.send_data.doctor_id,
                        is_default: 1
                    }
                    // save_card
                    this.mainService.api(data, 'add_instant_card', true)
                        .subscribe((data: any) => {
                            if (data.is_error == 1) {
                                if (data.override_text) {
                                    this.mainService.customPopups(data.override_text, 1);
                                } else {
                                    this.mainService.customPopups(data.flag, 1);
                                }
                            } else {
                                this.confirmAction();
                                if (this.data && this.data.action == 'Update') {
                                    this.mainService.customPopups('Card updated successfully.', 0);
                                } else {
                                    this.mainService.customPopups('Card added successfully.', 0);
                                }
                            }
                        }, (error: any) => {
                            console.log(error);
                        });
                } else {
                    _this.zone.run(_ => {
                        _this.new_address.cardError = response.error.message;
                    });
                }
            });
        }
    }

    /* */
    showSupportedDebitCard() {
        let data = {
            access_token: localStorage.getItem('token'),
            offset: 0,
            limit: 6000,
            search_string: '',
            doctor_id: this.data.send_data.doctor_id
        }
        this.mainService.api(data, 'instant_payout_support_bank_list', true)
            .subscribe((data: any) => {
                if (data.is_error == 0) {
                    let incProcessingLimitDialogRef = this.dialog.open(SimpleDialogComponent, {
                        width: '850px',
                        disableClose: true,
                        panelClass: 'simpleDialog',
                        data: {
                            type: 38,
                            title: 'Banks supported for Instant Payouts',
                            send_data: {
                                cardlist: data
                            }
                        }
                    });
                }
            });


    }

    searchDebitBank;
    banks = [];
    filtered_banks;
    filtered_banks_count;
    getFilteredInstantPayoutSupoortBanks(search_string) {
        setTimeout(() => {
            let filtered_banks = this.banks.filter(bank => bank.card_name.toLowerCase().indexOf(search_string.trim().toLowerCase()) !== -1);
            this.filtered_banks_count = filtered_banks.length;
            this.filtered_banks = filtered_banks.slice(0, 100);
        }, 100);
    }
    addService() {
        let a1: boolean = false;
        let val = this.add_product.terms.split(',');
        a1 = val.every(value => { return parseInt(value) < 100 });
        if(a1){
            if (this.add_product.dp_amount) {
                this.add_product.dp_amount = Number(this.add_product.dp_amount);
            }
            if (this.add_product.service_amount) {
                this.add_product.service_amount = Number(this.add_product.service_amount);
            }
            if (!this.add_product.pc_name) {
                this.mainService.customPopups('Please enter a valid service name', 1);
                return;
            }
            if (!this.add_product.service_amount) {
                this.mainService.customPopups('Please enter a valid service amount', 1);
                return;
            }
            if (!this.add_product.interest_rate && this.add_product.interest_rate != 0 && this.add_product.contract_type == 3) {
                this.mainService.customPopups('Please enter a valid interest rate', 1);
                return;
            }
            if ((Number(this.add_product.interest_rate) > 100 || this.add_product.interest_rate < 0) && this.add_product.contract_type == 3) {
                this.mainService.customPopups('Interest rate must be between 0% and 100%', 1);
                return;
            }

            if(this.downpayment_setting && this.downpayment_setting.downpayment_percent>0 && this.add_product.contract_type == 2){
                if (typeof this.add_product.dp_amount == 'string' || typeof this.add_product.dp_amount == 'object') {
                    this.mainService.customPopups('Please enter a valid downpayment amount', 1);
                    return;
                }
            }else if(this.downpayment_setting && this.downpayment_setting.new_ten_downpayment_percent>0 && this.add_product.contract_type == 3){
                if (typeof this.add_product.dp_amount == 'string' || typeof this.add_product.dp_amount == 'object') {
                    this.mainService.customPopups('Please enter a valid downpayment amount', 1);
                    return;
                }
            } else if(this.downpayment_setting && this.downpayment_setting.di_downpayment_percent>0 && this.add_product.contract_type == 6){
                if (typeof this.add_product.dp_amount == 'string' || typeof this.add_product.dp_amount == 'object') {
                    this.mainService.customPopups('Please enter a valid downpayment amount', 1);
                    return;
                }
            } else{
                this.add_product.dp_amount=0
            }

            if (this.add_product.dp_amount >= this.add_product.service_amount) {
                this.mainService.customPopups('Service amount must be greater than downpayment amount', 1);
                return;
            }
            let terms = this.add_product.terms.split(",").map(item => item.replace(/\D+/g, "")).filter(item => item != "" && item != "0");
            terms = terms.filter(function (item, pos, self) {
                return self.indexOf(item) == pos;
            })
            this.add_product.terms = terms.join(',');
            if (terms.length == 0) {
                this.mainService.customPopups('Please enter valid months', 1);
                return;
            } else if (terms.length > 10) {
                this.mainService.customPopups('The options available for terms should be less than or equal to 10', 1);
                return;
            }
            else {
                this.add_product.terms = terms.join(',');
            }
            if (!this.add_product.description) {
                this.mainService.customPopups('Please enter a valid description', 1);
                return;
            }
            if (this.add_product.website_navigation_link && !new RegExp(Regex.website_regex).test(this.add_product.website_navigation_link)) {
                this.mainService.customPopups('Please enter valid URL, as your customer will be redirected to website listed by you.', 1);
                return;
            }
            let params = {
                doctor_id: this.add_product.doctor_id,
                access_token: localStorage.getItem('token'),
                dp_amount: this.add_product.dp_amount,
                pc_name: this.add_product.pc_name,
                service_amount: this.add_product.service_amount,
                pc_description: this.add_product.description,
                terms: this.add_product.terms,
                website_navigation_link: this.add_product.website_navigation_link,
                type: 1,
                show_desc: this.add_product.show_desc ? 1 : 0,
                contract_type: String(this.add_product.contract_type)
            }
            if (params.website_navigation_link && params.website_navigation_link.indexOf("http://") != 0 && params.website_navigation_link.indexOf("https://") != 0) {
                params.website_navigation_link = `https://${params.website_navigation_link}`;
            }
            if (this.add_product.contract_type == 3) {
                params['interest_rate'] = Number(this.add_product.interest_rate);
                params['contract_type'] = String(this.add_product.contract_type);
            }

            let url = 'add_financing_product';
            if (this.add_product.pc_id) {
                url = 'update_financing_product'
                params['pc_id'] = this.add_product.pc_id;
            }
            this.mainService.api(params, url, false, 'object')
                .subscribe(data => {
                    if (data.is_error == 1) {
                        if (data.override_text || data.err) {
                            this.mainService.customPopups(data.override_text || data.err, data.is_error);
                        } else {
                            this.mainService.flagPopUps(data.flag, data.is_error);
                        }
                    } else {
                        if (this.add_product.pc_id) {
                            this.mainService.customPopups('Service updated successfully', 0);
                        } else {
                            this.mainService.customPopups('Service added successfully', 0);
                        }
                        this.confirmAction();
                    }
                });
        }
        else{
            this.mainService.customPopups('Terms should be less then or equal to 99 months.', 1)
        }
    }
    publish_or_update_packages() {
        if (this.show_additional_service && this.serviceBreakForm.invalid) {
            this.serviceBreakForm.markAsTouched();
            this.serviceBreakForm.markAllAsTouched();
            this.serviceBreakForm.markAsDirty();
            return;
        }
        if (this.dynamicPackage.service_name.trim().length == 0) {
            this.mainService.customPopups('Please enter a valid service name', 1);
            return;
        }
        if (this.dynamicPackage.description.trim().length == 0) {
            this.mainService.customPopups('Please enter a valid description', 1);
            return;
        }
        if (this.dynamicPackage.website_navigation_link && !new RegExp(Regex.website_regex).test(this.dynamicPackage.website_navigation_link)) {
            this.mainService.customPopups('Please enter valid URL, as your customer will be redirected to website listed by you.', 1);
            return;
        }
        this.dynamicPackage.add_package_list.filter((ele: any) =>{
            delete ele.amount_terms_type;
            if (isNaN(ele.interest_rate) || !ele.interest_rate){
                delete ele.interest_rate;
            }
        })
        let params = {
            doctor_id: this.dynamicPackage.doctor_id,
            access_token: localStorage.getItem('token'),
            dp_amount: 0,
            contract_type: String(this.data.send_data.add_product.contract_type),
            pc_name: this.dynamicPackage.service_name,
            service_amount: 0,
            pc_description: this.dynamicPackage.description,
            service_amount_type: this.dynamicPackage.amount_terms_type,
            terms: " ",
            products_array: this.dynamicPackage.add_package_list,
            additional_products_array: this.serviceBreakForm.value.items,
            website_navigation_link: this.dynamicPackage.website_navigation_link,
            type: 2,
            show_desc: this.dynamicPackage.show_desc ? 1 : 0
        }
        if (params.website_navigation_link && params.website_navigation_link.indexOf("http://") != 0 && params.website_navigation_link.indexOf("https://") != 0) {
            params.website_navigation_link = `https://${params.website_navigation_link}`;
        }

        if(this.serviceBreakForm.value.items.length == 0) {
            delete params.additional_products_array;
        }

        // api add url

        let url = 'add_financing_product';
        if (this.dynamicPackage && this.dynamicPackage["pc_id"]) {
            url = 'update_financing_product'
            params['pc_id'] = this.dynamicPackage["pc_id"];
        }
        this.mainService.api(params, url, false, 'object')
            .subscribe(data => {
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        if (data && data.tracking_id && data.tracking_id == 'downp414a') {
                            let doctorSettings = localStorage.getItem('doctorSettings') && getDoctorSettings();
                            if (params.contract_type == '2') {
                                this.mainService.customPopups(`You can't enter the down payment greater than ${doctorSettings.downpayment_percent}%`, data.is_error);
                            } else {
                                this.mainService.customPopups(`You can't enter the down payment greater than ${doctorSettings.new_ten_downpayment_percent}%`, data.is_error);
                            }
                        } else {
                            this.mainService.customPopups(data.override_text || data.err, data.is_error);
                        }
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.is_opt_disabled = false;
                    if (this.add_product.pc_id) {
                        this.mainService.customPopups('Service updated successfully', 0);
                    } else {
                        this.mainService.customPopups('Service added successfully', 0);
                    }
                    this.confirmAction();
                }
            });


    }
    writeToUsMessage = '';
    addWpQuery() {
        if (!this.writeToUsMessage || this.writeToUsMessage == '' || !this.writeToUsMessage.trim() || this.writeToUsMessage.trim() == '') {
            this.mainService.customPopups('Please enter a message', 1);
            return false;
        }
        let user_info = getUserProfile();
        var firstName = user_info.enterprise_first_name ? user_info.enterprise_first_name : (user_info.agent_id ? user_info.agent_name : user_info.doctor_first_name);
        var lastName = user_info.enterprise_last_name ? user_info.enterprise_last_name : (user_info.agent_id ? "" : user_info.doctor_last_name);
        var userphonenumber = user_info.enterprise_mobile ? user_info.enterprise_mobile : (user_info.agent_id ? user_info.agent_mobile : user_info.doctor_mobile);
        var useremail = user_info.enterprise_email ? user_info.enterprise_email : (user_info.agent_id ? user_info.agent_email : user_info.doctor_email);
        if (user_info.role_id != 4) {
            let locations = getStoredLocations();
            let selected_location = locations.filter(element => element.doctor_id == this.data.send_data.doctor_id);
            firstName = selected_location[0].doctor_first_name;
            lastName = selected_location[0].doctor_last_name;
            userphonenumber = selected_location[0].doctor_mobile;
            useremail = selected_location[0].doctor_email;
        }
        var params = {
            access_token: localStorage.getItem('token'),
            doctor_id: this.data.send_data.doctor_id,
            type: 1,
            name: firstName + " " + lastName,
            phone: userphonenumber,
            src_url: 'Inquiry made from Business Panel ' + window.location.href,
            message: this.writeToUsMessage,
            specialty: user_info.speciality_name ? user_info.speciality_name : 'N.A.',
            zip: user_info.zip ? user_info.zip : 'N.A.',
            address: user_info.practice_address ? user_info.practice_address : 'N.A.',
            email: useremail,
        }
        this.mainService.api(params, 'add_wp_contact_query', false, 'object')
            .subscribe(data => {
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text || data.err, data.is_error);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.mainService.customPopups('Message sent successfully', 0);
                    this.writeToUsMessage = '';
                    this.confirmAction();
                }
            });
    }

    tutorial_videos = [];
    selected_video = { url: null };
    getTutorialVideos() {
        const data = {
            access_token: localStorage.getItem('token')
        };
        this.mainService.api(data, 'get_tutorial_videos', false)
            .subscribe((data: any) => {
                if (data && data.is_error == 0) {
                    this.tutorial_videos = data.data;
                    this.selected_video = this.tutorial_videos[0];
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        this.mainService.customPopups(data.override_text, data.is_error);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }
    selected_location = null;
    locationSelected() {
        if (this.selected_location) {
            this.dialogRef.close(this.selected_location);
        } else {
            this.mainService.customPopups('Please select a location.', 1);
        }
    }
    getCMSHTML() {
        let template_name = "BUSINESS_NON_MEDICAL_TERMS_AND_CONDITION";
        if (this.data.type == 47) {
            template_name = "TERMS_AND_CONDITION";
        }
        const data = {
            template_name: template_name,
            type: 1
        }
        this.mainService.api(data, `cms_details_for_panel`, false, 'object')
            .subscribe(response => {
                if (response.is_error) {
                    this.dynamic_html = '<h3 class="text-center">Unable to fetch content from server.</h3>';
                } else {
                    this.dynamic_html = response.data.content;
                }
            });
    }
    dynamic_html = '<h3 class="text-center">Loading...</h3>';

    acceptTermsCondition() {
        var data = {
            access_token: localStorage.getItem('token')
        };
        if (this.data.send_data && this.data.send_data.doctor_id) {
            data['doctor_id'] = this.data.send_data.doctor_id;
        }
        this.mainService.api(data, `accept_term_condition`, false, 'object')
            .subscribe(response => {
                if (response.is_error) {
                    if (response.override_text) {
                        this.mainService.customPopups(response.override_text, 1);
                    } else {
                        this.mainService.flagPopUps(response.flag, response.is_error);
                    }
                } else {
                    this.dialogRef.close();
                }
            });
    }
    logout() {
        localStorage.removeItem('environment');
        const data = {
            access_token: localStorage.getItem('token'),
            device_type: environment.device_type,
            app_type: environment.app_type,
            app_version: environment.app_version,
            device_token: environment.device_token,
            device_id: localStorage.getItem('user')
        };
        this.mainService.api(data, `logout`, true, 'object')
            .subscribe(_data => {
                this.ClearLoginData()
                this.router.navigate(['login']);
            });
    }
    setRecurringData() {
        var data = {
            access_token: localStorage.getItem('token'),
            pf_id: this.contractData.pf_id,
            treatment_amount: parseFloat(this.edit_contract_data.treatment_amount)
        }
        this.mainService.api(data, 'get_edit_finance_plans', true)
            .subscribe((data: any) => {
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text || data.err, 1);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.plan_array = data.months;
                    this.contractData.old_recurring_amount_with_fee = this.plan_array[0].old_recurring_amount_with_fee;
                    this.edit_contract_data.new_recurring_amount = null;
                    this.edit_contract_data.tenure = null;
                    this.edit_contract_step = 2;
                }
            }, (error: any) => {
                console.log(error);
            });
    }


    routeMe(data, type) {
        try {

            let data_1 = {
                access_token: localStorage.getItem('token'),
                type: 5,
                revive_add_cross_count: type == 'revive_add_cross_count' ? 1 : 0,
                revive_finance: type == 'revive_finance' ? 1 : 0,
                revive_training: type == 'revive_training' ? 1 : 0,
                revive_callback: type == 'revive_callback' ? 1 : 0,
                revive_add_bank: type == 'revive_add_bank' ? 1 : 0,
            }
            this.mainService.api(data_1, 'update_marketing_popup_status', true).subscribe((data_2) => {
                if (data_2.is_error == 0) {
                    this.dialogRef.close();
                    this.auth.accessTokenLogin();
                    if (type.trim() == "revive_callback") {
                        this._shared.callYouBackModal()
                    }
                    if (data !== '') {
                        this.router.navigate([data])
                        this.dialogRef.close(1);
                        return
                    }
                    // if (type !== 'revive_add_cross_count') {
                    this.dialogRef.close(type === 'revive_add_cross_count' ? 0 : 1);
                    // }
                }
            })
        } catch (error) {
            console.log(error);

        }
    }

    updateReference() {
        var letters = /^[0-9a-zA-Z\.\@\+]+$/;
        if (!this.data.email.match(letters)) {
            this.mainService.customPopups('Please enter a valid Customer Reference Number', 1);
            return;
        }
        let data = {
            access_token: localStorage.getItem('token'),
            contract_id: this.data.send_data.contract_id,
            doctor_record_id: this.data.email
        }
        this.mainService.api(data, 'update_doctor_record_id', true).subscribe((data) => {
            if (data.is_error == 0) {
                this.mainService.customPopups(this.data.added == 0 ? 'Succesfully added Customer Reference Number' : 'Succesfully updated Customer Reference Number', 0)
                this.dialogRef.close(1)
            }
        })
    }

    getCard() {
        this.mainService.stripe_element.mount('#' + 'cancel_contract');
    }
    getCard_1() {
        this.mainService.stripe_element.mount('#' + 'edit_recurring');
    }

    checkboxed = [];
    checkFunction(event, i) {
        if(typeof this.checkboxed[1] == 'object'){
            this.checkboxed = this.checkboxed.reduce((item, o) => {
                if(!item.some(obj => obj.month === o.month) && typeof item == 'object') {
                  item.push(o);
                }
                return item;
            },[]);
        }

        if ((this.checkboxed.indexOf(i) == -1 || this.checkboxed.length == 0) && event.target.checked == true) {
            this.checkboxed.push(i)
        }
        else {
            this.checkboxed = this.checkboxed.filter(item => {
                if (typeof item == 'object') {
                    return item.month !== this.data.allContracts[i].month;
                }
                else {
                    return item !== i
                }
            })
        }
    }

    routeMeV2(data) {
        this.dialogRef.close();
        if (data == '/app/finance') {
            if (this.userInfo[0].role_id == 4) {
                this.router.navigate([data]);

            }
            else {
                this._shared.getSelectedBusiness(data)
            }
        }
        else {
            this.router.navigate([data]);
        }
    }

    downloadPdf() {
        try {
            var est_serv_amount = (this.data.totalServAmt >= 0 && this.data.totalServAmt !== null && this.data.totalServAmt !== '') ? this.data.totalServAmt : this.data.estimatedServiceCost;
            var pdfMonthArr = [];
            if (this.data.paymentType == 'noFee' || this.data.paymentType == 'easyFinance' || this.data.paymentType == 'inHouse') {
                pdfMonthArr.push(this.data.send_data.months_array);
                if (this.data.customNoFeeAvailableMonth.length) {
                    this.data.customNoFeeAvailableMonth.forEach(ele => pdfMonthArr.push(ele.month));
                }
            } else {
                this.data.filteredArray.forEach(element => {
                    pdfMonthArr.push(element.month)
                });
            }
            pdfMonthArr = pdfMonthArr.filter(function (el) {
                return el != null;
            });

            let data = {
                access_token: localStorage.getItem('token'),
                // di
                // tslint:disable:max-line-length
                contract_type: Number(this.data.paymentType == 'noFee' ? 2 : this.data.paymentType == 'inHouse' ? 3 : this.data.paymentType == 'easyFinance' ? 4 : 1),
                downpayment_amount: Number(this.data.downpaymentCost),
                fixed_flat_fee: Number(this.data['enrollment_fee']),
                interest_rate: Number(this.data.interestRateAmt ? this.data.interestRateAmt : 0),
                months: this.checkboxed.map((item, index) => {
                    if (typeof (item) == 'object') {
                        return item.month.toString()
                    }
                    else {
                        return this.data.allContracts[item].month.toString();
                    }
                }).toString(),
                treatment_amount: Number(est_serv_amount),
                doctor_id: Number(this.data.doctor_id)
            }
            if (this.data.send_data.contract_type) {
                data.contract_type = this.data.send_data.contract_type;
            }
            this.mainService.downloadApi(data, `pf_pdf_plan2`, 0)
                .subscribe(response => {
                });
        } catch (error) {
            console.log(error);
        }
    }

    openDialog() {
        this.dialog.open(DialogContentExampleDialog, {
            width: '550px',
            height: '340px',
            panelClass: 'simpleDialog',
            data: {
                data: this.selected_video
            }
        });
    }

    savePackage(formval: NgForm) {
        let a1: boolean = false;
        let val = formval.value.terms.split(',');
        a1 = val.every(value => { return value < 100 });

        if (a1) {
            formval.value.service_amount = Number(formval.value.service_amount)
            if (formval.value.min_down_payment) {
                formval.value.min_down_payment = Number(formval.value.min_down_payment)
            }
            if (this.dynamicPackage.service_name.trim().length == 0) {
                this.mainService.customPopups('Please enter a valid service name', 1);
                return;
            }
            if (this.dynamicPackage.description.trim().length == 0) {
                this.mainService.customPopups('Please enter a valid description', 1);
                return;
            }
            if (!formval.value.service_amount) {
                this.mainService.customPopups('Please enter service amount', 1)
                return;
            }
            if (!formval.value.interest_rate && formval.value.interest_rate != 0 && this.data.send_data.add_product.contract_type == 3) {
                this.mainService.customPopups('Please enter valid interest rate', 1)
                return;
            }
            if (formval.value.interest_rate && (formval.value.interest_rate > 100 || formval.value.interest_rate < 0)) {
                this.mainService.customPopups('Interest rate must be between 0% and 100%', 1)
                return;
            }

            if(this.downpayment_setting && this.downpayment_setting.downpayment_percent>0){
                if (typeof formval.value.min_down_payment == 'string' || typeof formval.value.min_down_payment == 'object') {
                    this.mainService.customPopups('Please enter a valid downpayment amount', 1)
                    return;
                }
            }

            if (formval.value.min_down_payment >= formval.value.service_amount) {
                this.mainService.customPopups('Service amount must be greater than downpayment amount', 1)
                return;
            }
            if (formval.value.terms_type == 1) {
                let terms = formval.value.terms.split(",").map(item => item.replace(/\D+/g, "")).filter(item => item != "" && item != "0");
                terms = terms.filter(function (item, pos, self) {
                    return self.indexOf(item) == pos;
                })

                if (terms.length == 0) {
                    this.mainService.customPopups('Please enter valid months', 1)
                    return;
                }
                else if (terms.length > 10) {
                    this.mainService.customPopups('The options available for terms should be less than or equal to 10', 1);
                    return;
                }
                else {
                    formval.value.terms = terms.join(',');
                }
            }
            if (formval.value.terms_type == 2) {
                let terms = Number(formval.value.terms);
                if (!terms) {
                    this.mainService.customPopups('Please enter valid months', 1)
                    return;
                }
            }

            if (formval.value.service_amount && this.dynamicPackage.add_package_list) {
                for (const [index, value] of this.dynamicPackage.add_package_list.entries()) {
                    if (value.max_service_amount == formval.value.service_amount) {
                        if (this.dynamicPackage.edit_dynamic_package_index != index) {
                            this.mainService.customPopups('Please choose different service amount from the previous', 1)
                            return;
                        }
                    }
                }
            }
            this.is_opt_disabled = true;
            this.dynamicPackage.amount_terms_type = Number(formval.value.amount_terms_type) || this.dynamicPackage.amount_terms_type;
            if (this.dynamicPackage.edit_dynamic_package_index != -1) {
                this.dynamicPackage.add_package_list.splice(this.dynamicPackage.edit_dynamic_package_index, 1, { max_service_amount: formval.value.service_amount, min_dp_amount: formval.value.min_down_payment?formval.value.min_down_payment:0, terms_type: formval.value.terms_type, terms: formval.value.terms, service_amount_type: Number(formval.value.amount_terms_type),  interest_rate: Number(formval.value.interest_rate) });
            } else {
                this.dynamicPackage.add_package_list.push({ max_service_amount: formval.value.service_amount, min_dp_amount: formval.value.min_down_payment?formval.value.min_down_payment:0, terms_type: formval.value.terms_type, terms: formval.value.terms, service_amount_type: Number(formval.value.amount_terms_type), interest_rate: Number(formval.value.interest_rate) });
            }
            this.dynamicPackage.show_input_value_container = false;
            this.dynamicPackage.edit_dynamic_package_index = -1;
            this.dynamicPackage.min_down_payment = 0;
            this.dynamicPackage.service_amount = null;
            this.dynamicPackage.terms = "";
            this.dynamicPackage.interest_rate = this.doctorSettings && this.doctorSettings.guarantee_percent_new_ten ? this.doctorSettings.guarantee_percent_new_ten: 0;
        } else {
            this.mainService.customPopups('Terms should be less then or equal to 99 months.', 1)
        }
    }
    calcelAddpackage() {
        this.dynamicPackage.show_input_value_container = false;
        this.dynamicPackage.edit_dynamic_package_index = -1;
        this.dynamicPackage.min_down_payment = 0;
        this.dynamicPackage.service_amount = null;
        this.dynamicPackage.terms = "";
        this.dynamicPackage.interest_rate = null;
        this.dynamicPackage.amount_terms_type = this.dynamicPackage.add_package_list[0].service_amount_type;
    }

    termsvalidator = function (value, type) {

        if (type == "1" || type == 1) {
            const reg = new RegExp('[0-9\.\,]');
            let val = ['Control', "a", 'ArrowLeft', "ArrowRight", "Backspace", "Delete"];
            if (!val.includes(value.key) && !reg.test(value.key)) {
                value.preventDefault();
            }
        }
        else if (type == "2") {
            const reg = new RegExp('[0-9]');
            if (reg.test(value.key) || value.keyCode == 8 || value.keyCode == 46) {
            }
            else {
                value.preventDefault();
            }
        }
    }

    delete_dynamic_package_in_edit = function (index) {
        if (this.dynamicPackage.add_package_list.length == 1) {
            this.dynamicPackage.show_input_value_container = true;
        }
        this.dynamicPackage.add_package_list.splice(index, 1);
        this.dynamicPackage.edit_dynamic_package_index = -1;

        this.is_opt_disabled =false

    }

    edit_package(index) {
        this.is_opt_disabled = false;
        this.dynamicPackage.show_input_value_container = false;
        this.dynamicPackage.terms = this.dynamicPackage.add_package_list[index].terms;
        this.dynamicPackage.interest_rate = this.dynamicPackage.add_package_list[index].interest_rate;
        this.dynamicPackage.service_amount = this.dynamicPackage.add_package_list[index].max_service_amount;
        this.dynamicPackage.min_down_payment = this.dynamicPackage.add_package_list[index].min_dp_amount;
        this.dynamicPackage.terms_type = this.dynamicPackage.add_package_list[index].terms_type;
        this.dynamicPackage.amount_terms_type = this.dynamicPackage.amount_terms_type || this.dynamicPackage.add_package_list[index].service_amount_type;
        this.add_dynamic_product_temp = {
            terms: this.dynamicPackage.add_package_list[index].terms,
            service_amount: this.dynamicPackage.add_package_list[index].max_service_amount,
            dp_amount: this.dynamicPackage.add_package_list[index].min_dp_amount,
            terms_type: this.dynamicPackage.add_package_list[index].terms_type,
            interest_rate: this.dynamicPackage.add_package_list[index].interest_rate,
            amount_terms_type: this.dynamicPackage.add_package_list[index].service_amount_type,
        }
        this.dynamicPackage.edit_dynamic_package_index = index;
    }

    cancel_update_package = function () {
        if (this.dynamicPackage.edit_dynamic_package_index != -1) {
            this.dynamicPackage.add_package_list.splice(this.dynamicPackage.edit_dynamic_package_index, 1, { max_service_amount: this.add_dynamic_product_temp.service_amount, min_dp_amount: this.add_dynamic_product_temp.dp_amount, terms_type: this.add_dynamic_product_temp.terms_type, terms: this.add_dynamic_product_temp.terms, interest_rate: this.add_dynamic_product_temp.interest_rate, amount_terms_type: this.add_dynamic_product_temp.amount_terms_type });
        }
        this.dynamicPackage.terms = "";
        this.dynamicPackage.service_amount = "";
        this.dynamicPackage.downpayment_amount = "";
        this.dynamicPackage.edit_dynamic_package_index = -1;
    }

    omit_special_char(event) {
        let k;
        k = event.charCode;
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

    customerSupport() {
        this.router.navigate(['/app/help/support']);
    }

    changeMyScreen(pot_contract_type, pot_contract_step) {
        this.pot_contract_type = pot_contract_type;
        if (this.doctorSettings.show_variable_service == 1) {
            this.pot_contract_step = pot_contract_step;
        } else {
            this.addServicepopup(1);
        }
    }
    selectReason(val){
        const exists = this.reason.includes(val);
        this.other_reason = '';
        if (exists) {
            const index = this.reason.indexOf(val);
            if (index > -1) {
                this.reason.splice(index, 1);
            }
        } else {
            this.reason.push(val);
        }

        if(this.reason.includes(100) && (this.other_reason && this.other_reason.length) == 0){
            this.showCloseBtn =  false;
        } else if(this.reason.length == 0){
            this.showCloseBtn =  false;
        } else{
            this.showCloseBtn = true;
        }

    }

    sendCloseData(){
        const data = {
            access_token: localStorage.getItem('token'),
            doctor_id: this.userInfo[0].doctor_id,
            reason_id:this.reason.toString(),
            other_reason: this.other_reason ? this.other_reason.trim(): ''
        };
        if(this.reason.includes(100) && this.other_reason.trim().length == 0){
            this.mainService.customPopups("Please add a valid reson", 1);
        }else{
            this.mainService.api(data, 'cancel_business_contract', false)
            .subscribe((data: any) => {
                if (data && data.is_error == 0) {
                    this.dialogRef.close();
                    this.mainService.customPopups("Thank you for the feedback.",0);
                    this.router.navigate(['/app/dashboard']);
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        this.mainService.customPopups(data.err, data.is_error);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
        }
    }

    addNext(form,value){
        let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        if(this.editpatientVal){
            this.editpatientVal = false;
        }
        if (form.invalid) {
            if (form.value.first_name == null || form.value.first_name.length == 0) {
                this.mainService.customPopups('Please enter a valid first name', 1);
                return;
            }
            if (form.value.last_name == null || form.value.last_name.length == 0) {
                this.mainService.customPopups('Please enter a last name', 1);
                return;
            }
            if (form.value.user_email !== null || form.value.user_email.length != 0) {
                let mail = form.value.user_email ? form.value.user_email : this.data.send_data.user_email;
                if (!EMAIL_REGEXP.test(mail)) {
                    this.mainService.customPopups('Please enter a valid mail', 1);
                    return;
                }
            }else{
                this.mainService.customPopups('Please enter a valid mail', 1);
            }
            if (form.value.user_phone !== null  || form.value.user_phone.length != 0) {
                var mobile = form && form.value.user_phone ? form.value.user_phone.replace(/-/g, '') : null;
                if (mobile && mobile.length <= 9) {
                    this.mainService.customPopups('Please enter valid phone number', 1);
                    return false;
                }
            }else{
                this.mainService.customPopups('Please enter valid phone number', 1);
            }

        }else{
            if(form.value && (form.value.first_name || form.value.last_name || form.value.user_phone || form.value.user_email)){
                if(form.value.user_phone && form.value.user_phone.includes('0000000000')){
                    this.mainService.customPopups('Please enter valid phone number', 1);
                    return false;
                }

                if (form.value.user_email && this.add_proposal_users) {
                    for (const [index, value] of this.add_proposal_users.entries()) {
                        if (value.patient_email == form.value.user_email) {
                            if (this.edit_proposal_index != index) {
                                this.mainService.customPopups('Please choose different email from the previous.', 1)
                                return;
                            }
                        }
                    }
                }

                if (form.value.user_phone && this.add_proposal_users) {
                    for (const [index, value] of this.add_proposal_users.entries()) {
                        if (value.patient_mobile == form.value.user_phone) {
                            if (this.edit_proposal_index != index) {
                                this.mainService.customPopups('Please choose different phone number from the previous.', 1)
                                return;
                            }
                        }
                    }
                }
            }else{
                if(value == 1){
                this.showNewInputs = true;}
            }

            if(value == 1 && (form.form.value.first_name || form.form.value.last_name || form.form.value.user_email || form.form.value.user_phone)){
                this.showcancell = true;
                this.add_proposal_users.push({
                    patient_first_name: form.form.value.first_name,
                    patient_last_name:form.form.value.last_name,
                    patient_email: form.form.value.user_email,
                    patient_mobile:form.form.value.user_phone,
                })
                form.form.reset();
            }
            else{
                this.showcancell = true;

                let users = this.add_proposal_users;
                if(form.form.value.first_name || form.form.value.last_name || form.form.value.user_email || form.form.value.user_phone){
                    users.push({
                        patient_first_name: form.form.value.first_name,
                        patient_last_name:form.form.value.last_name,
                        patient_email: form.form.value.user_email,
                        patient_mobile:form.form.value.user_phone,
                    })
                    form.form.reset();
                }
                if(value !=1){

                    let data = {
                        access_token: localStorage.getItem('token'),
                        split_req_id: this.data.send_data.split_req_id,
                        downpayment_amount: this.data && this.data.downpaymentCost && this.data.downpaymentCost,
                        treatment_amount: this.data && this.data.send_data && this.data.send_data.treatment_amount && this.data.send_data.treatment_amount,
                        interest_rate: this.data && this.data.send_data && this.data.send_data.interest_rate && this.data.send_data.interest_rate,
                        contract_type: this.data && this.data.send_data && this.data.send_data.contract_type && this.data.send_data.contract_type,
                        months_array: this.checkboxed.map((item, index) => {
                            if (typeof (item) == 'object') {
                                return item.month.toString()
                            }
                            else {
                                return this.data.allContracts[item].month.toString();
                            }
                        }),
                        doctor_id: this.data.send_data.doctor_id,
                        fixed_flat_fee: this.data['enrollment_fee'],
                        start_date: '',
                        end_date: '',
                        patient_details: users
                    };
                    if (this.data.send_data.serviceBreakdown && this.data.send_data.serviceBreakdown[0].price >= 0 && this.data.send_data.serviceBreakdown[0].price != '') {
                        Object.assign(data, { contract_service_record: this.data.send_data.serviceBreakdown });
                    }
                    if (this.proposalDurationModel == 'Custom Date') {
                        data.start_date = this.datepipe.transform(form.value.startDate, 'yyyy-MM-dd'),
                        data.end_date = this.datepipe.transform(form.value.endDate, 'yyyy-MM-dd')
                    } else {
                        data.start_date = this.datepipe.transform(this.proposalStartDate, 'yyyy-MM-dd'),
                        data.end_date = this.datepipe.transform(this.proposalEndDate, 'yyyy-MM-dd')
                    }
                    this.loaderService.show();
                    this.mainService.api(data, 'send_split_plans_to_multiple', false).subscribe((data: any) => {
                        if (data.is_error == 0) {
                            this.proposalSent = true;
                            this.fillForm = false;
                            this.showNewInputs = false;
                        } else {
                            this.editpatientVal = false;
                            this.proposalSent = false;
                            this.loaderService.hide();
                            if (data.override_text || data.err) {
                                this.mainService.customPopups(data.override_text || data.err, data.is_error);
                            } else {
                                this.mainService.flagPopUps(data.flag, data.is_error);
                            }
                        }
                    });
                }
            }

        }
    }


    addServicepopup(service_type) {
        let data = {
            contract_type: this.pot_contract_type,
            service_type: service_type
        }
        if (this.add_product.interest_rate) {
            data['interest_rate'] = this.add_product.interest_rate
        }
        this.dialogRef.close(data);
    }

    upgradeSubscription() {
        if(this.data.send_data && this.data.send_data.path && (this.data.send_data.path == 'finance' || this.data.send_data.path == 'api')){
            this.router.navigate(['/app/pricing'], { queryParams: { sp_id: 2, path: '1' } });
        } else if(this.data.send_data.is_ar == 1){
            this.router.navigate(['/app/pricing'], { queryParams: { sp_id: 2, path: '1' } });
        }
        else{
            this.router.navigate(['/app/pricing']);
        }
        this.dialogRef.close();
    }

    changeSubscription(api) {
        const obj: any = {
            access_token: localStorage.getItem('token')
        };
        this.mainService.api(obj, `${api}`, false, 'object')
            .subscribe(response => {
                if (!response.is_error) {
                    if (api === this.changeSubApis.cancel_subscription) {
                        this.mainService.customPopups('Subscription cancelled successfully', 0);
                    } else {
                        this.mainService.customPopups('Subscription is restored successfully', 0);
                    }
                    //   this.sub_details.sub_cancel = !this.sub_details.sub_cancel;
                    return;
                } else {
                    this.mainService.customPopups('Something went wrong', 1);
                    return;
                }
            });
    }


    openWriteToUs() {
        if (this.selected_location1 && this.selected_location1.id) {
            this.dialogRef.close()
            this._shared.openWriteToUs(this.selected_location1.id);
        } else {
            this.mainService.customPopups('Please select a location from the header.', 1);
        }
    }

    removeSpecificPatient(index){
        this.add_proposal_users.splice(index,1)
    }

    editSpecificPatient(index){
        this.showNewInputs = true;
        this.editpatientVal= true;
        this.user_obj ={
            patient_first_name: this.add_proposal_users[index].patient_first_name,
            patient_last_name: this.add_proposal_users[index].patient_last_name,
            patient_email: this.add_proposal_users[index].patient_email,
            patient_mobile: this.add_proposal_users[index].patient_mobile
        }
        this.add_proposal_users.splice(index,1);
    }

    sendCustomerProposal(form,value){
        this.showNewInputs =  false;
        this.addNext(form,value);
    }

    //  import data csv and xls
    importFile(files: FileList) {
        let type = files[0].name.split('.')[1];0
        if ((files[0].type == 'text/csv' || type == 'csv') && files && files.length > 0) {
            const file: File = files.item(0);
            this.proposalUploadData(file);

        } else if ((files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type == 'xlsx' || type == 'xls') && files && files.length > 0) {
            const reader = new FileReader();
            let workbookkk;
            let XL_row_object;
            let json_object;
            reader.readAsBinaryString(files[0]);
            return new Promise((resolve, reject) => {
                reader.onload = function () {
                    const data = reader.result;
                    workbookkk = read(data, { type: 'binary' });
                    workbookkk.SheetNames.forEach(function (sheetName) {
                        XL_row_object =  utils.sheet_to_json(workbookkk.Sheets[sheetName]);
                        json_object = JSON.stringify(XL_row_object);

                        let list = [];
                        for (let i = 0; i < XL_row_object.length; i++) {
                            list[i] = {};
                            list[i].patient_first_name = XL_row_object[i]['First Name'];
                            list[i].patient_last_name = XL_row_object[i]['Last Name'];
                            list[i].patient_email = XL_row_object[i]['Email ID'];
                            list[i].patient_mobile = XL_row_object[i]['Phone Number'] ? String(XL_row_object[i]['Phone Number']).replace(/\D+/g, '') : '';

                        }
                        if (list && list.length > 0) {
                            this.csv_proposal_array = list;
                            this.proposalUploadData(list);
                        }
                        resolve(list);
                    });
                };
            });
        } else {
            alert('Invalid File');
        }

    }

    //patient data upload
    proposalUploadData(result: any) {
        let fd = new FormData();
        fd.append("access_token", localStorage.getItem('token')),
        fd.append("split_records", result)
        this.mainService.api(fd, 'bulk_split_requests', false).subscribe((response: any) => {
            if (response.is_error === 0) {
                this.proposalSent = true;
                this.mainService.customPopups("Data upload successfully",0);
                this.dialogRef.close();

            }else{
                this.proposalSent = false;
                this.mainService.customPopups(response.override_text || response.err, 1);
            }
        });
    }

    checkReason(event){
        if (event.target.selectionStart === 0 && event.code === 'Space') {
            event.preventDefault();
            return;
        }

        if(event.target.textLength + 1 == 0){
            this.showCloseBtn =  false;
        } else if((event.key == 'Backspace' && event.target.textLength - 1 == 0) || (event.key == 'Backspace' && event.target.textLength == 0)){
            this.showCloseBtn = false;
        }else{
            this.showCloseBtn = true;
        }

    }

    selectSubscriptionPayment(i, cardObject) {
        if (this.selectDeafultCard && i == this.card_index) {
            this.selectDeafultCard = false;
            this.card_index = null;
            this.card_object = null;
            setTimeout(() => {
                this.mainService.stripe_element.mount('#' + 'add_card');
            }, 200);
        } else {
            this.selectDeafultCard = true;
            this.card_index = i;
            this.card_object = cardObject;
        }
    }

    payWithDefaultCard() {
        this.iscardSubmitted = true;
        this.dialogRef.close(this.card_object);
    }

    addNewCard() {
        this.selectDeafultCard = false;
        this.card_index = null;
        this.card_object = null;
        setTimeout(() => {
            this.mainService.stripe_element.mount('#' + 'add_card');
        }, 200);
    }
  goto_forgot_password() {
    let doctor_details = localStorage.getItem("userProfileData") ? getUserProfile() : [{}]
    let doctor_email;
    // localStorage.clear();
    if(doctor_details && doctor_details.role_id == 1) {
      doctor_email = doctor_details.enterprise_email;
    } else {
      doctor_email = doctor_details.doctor_email;
    }

    this._shared.clearLocalStorage();
    this.ClearLoginData();
    // this.mainService.device_id('');
    this.router.navigate(['/forgot-password']);
    this.dialogRef.close();
  }

    myFilter = (d: Date): boolean => {
        if(!d){
            return;
        }
        const day = d.getDay();
        // Prevent Saturday and Sunday from being selected.
        return day !== 0 && day !== 6;
      }

    getTimeSlots() {
        this.mainService
    }

    fetchTrainingTypes() {
        let data = {
          access_token: localStorage.getItem('token'),
        };
        this.mainService.api(data, 'fetch_training_types', true).subscribe((data: any) => {
          if (data && data.is_error == 0) {
            this.training_types = data.data.filter(type => type.only_visible_to_admin == 0);
            this.selected_training = this.training_types[0];
            this.training_type = this.selected_training['type_id'];
            this.fetchTrainingTimezones();
          }
        }, (error: any) => {
          console.log(error);
        });
    }

    fetchTrainingTimezones() {
    let data = {
        access_token: localStorage.getItem('token'),
    };
    this.mainService.api(data, 'fetch_timezones', true)
        .subscribe((data: any) => {
        if (data && data.is_error == 0) {
            this.training_timezones = []
            var timezoneData = data.data;
            for (var i = 0; i < timezoneData.length; i++) {
            var tzOffset = (parseInt(timezoneData[i].val.substring(0, timezoneData[i].val.length - 2)) * 60) + parseInt(timezoneData[i].val.substring(timezoneData[i].val.length - 2));
            var timezoneHours = parseInt((parseInt((tzOffset + "")) / 60) + "");
            timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
            var timezoneMinutes = (tzOffset % 60);
            timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
            var timezoneString = (tzOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;
            this.training_timezones.push({
                code: timezoneData[i].offset,
                val: timezoneData[i].val,
                timezoneName: timezoneData[i].name,
                tzOffset: tzOffset,
                timezoneString: timezoneString,
            });
            }
            this.timezones = this.training_timezones;
            var selected_zone_name = this.training_timezones[0].timezoneName;
            var selectedUtcOffset = this.training_timezones[0].tzOffset;
            var currentUtcOffset = moment().utcOffset();
            var timezoneWithCurrentUtcOffset = this.training_timezones.find((timezone) => timezone.tzOffset === currentUtcOffset)
            if (timezoneWithCurrentUtcOffset) {
            selected_zone_name = timezoneWithCurrentUtcOffset.timezoneName;
            selectedUtcOffset = timezoneWithCurrentUtcOffset.tzOffset;
            }
            this.current_timezone = selected_zone_name + "****" + selectedUtcOffset;
        //   if (this.user_info && this.user_info[0] && this.user_info[0].role_id != 4) {
        //     this.locations = getStoredLocations();
        //     if (!this.locations && this.locations.length == 0) {
        //       this.mainService.customPopups('No location Found', 1);
        //     //   this._router.navigate(['/app/dashboard']);
        //     } else if (this.locations.length >= 1) {
        //       this.selected_location = this.locations[0].doctor_id;
        //       this.getBookableTimeSlots();
        //     } else if (this.old_event_id) {
        //       if (localStorage.getItem('reschedule_doctor_id')) {
        //         this.selected_location = parseInt(localStorage.getItem('reschedule_doctor_id'));
        //         this.getBookableTimeSlots();
        //       } else {
        //         // this._router.navigate(['/app/help/trainings/list']);
        //       }
        //     }
        //   } else {
            this.locations = getStoredLocations();
            this.getBookableTimeSlots();
        //   }
        }
        }, (error: any) => {
        console.log(error);
        });
    }

    getBookableTimeSlots() {
    // this.showConfirm = false;
    this.openboxes = false;
    this.training_data = [];
    var selectedUtcOffset = parseInt(this.current_timezone.split("****")[1]);
    var timezoneHours = parseInt(String(selectedUtcOffset / 60));
    timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
    var timezoneMinutes = (selectedUtcOffset % 60);
    timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
    var timezoneString = (selectedUtcOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;

    var startWeekDay = moment().utcOffset(selectedUtcOffset).day();
    var begin = moment().utcOffset(selectedUtcOffset).startOf('isoWeek').isoWeekday(startWeekDay).add(this.offsetFromCurrentWeek, "weeks");

    for (let i = 0; i < 36; i++) {
        if (begin.day() !== 6 && begin.day() !== 0) {
        var dateString = begin.format('MMM DD');
        var dateSlotsObj = {
            dayName: begin.format('dddd'),
            date: dateString,
            shortDate: begin.format("YYYY-MM-DD"),
            fullDateString: begin.format(),
            all_slots: []
        }

        var all_slots = [];
        for (var j = 0; j < (24 * 4); j++) {
            var timeHours = parseInt(String(j / 4));
            var timeMinutes = ((j % 4) * 15);
            var timeString = (((timeHours >= 10 ? "" : "0") + timeHours) + ":" + ((timeMinutes >= 10 ? "" : "0") + timeMinutes));
            if (timeMinutes === 0) {
            all_slots.push({
                time: timeString,
                disable: 1,
                time_slots: [],
                timeAmPm: moment(moment().format("YYYY-MM-DD") + "T" + timeString).format("hh:mm A"),
            });
            }
            all_slots[all_slots.length - 1].time_slots.push({
            time_slot: timeString,
            timeAmPm: moment(moment().format("YYYY-MM-DD") + "T" + timeString).format("hh:mm A"),
            fullDateTimeString: moment(begin.format("YYYY-MM-DD") + "T" + timeString + ":00" + timezoneString).format(),
            disable: 1
            });
        }
        dateSlotsObj.all_slots = all_slots;
        this.training_data.push(dateSlotsObj);
        this.training_data = this.training_data.filter((ele) => ele.shortDate === this.selectedDate)
        }
        begin.add('d', 1);
    }

    var startDateString = this.training_data[0].fullDateString;
    var endDateTimestamp = parseInt(moment(this.training_data[this.training_data.length - 1].fullDateString).utc().format("X")) + (24 * 35 * 60 * 60);
    var endDateString = moment(endDateTimestamp * 1000).utcOffset(selectedUtcOffset).format();

    var reqData = {
        access_token: localStorage.getItem('token'),
        start_date: startDateString,
        end_date: endDateString,
        training_type: this.training_type,
    }
    if (this.user_info && this.user_info[0] && this.user_info[0].role_id != 4) {
        /*  if (this.old_event_id) {
        reqData['doctor_id'] = localStorage.getItem('reschedule_doctor_id');
        } else */ if (this.selected_location) {
        reqData['doctor_id'] = this.selected_location;
        } else {
        this.mainService.customPopups('Please select a location', 1);
        return false;
        }
    }
    this.mainService.api(reqData, 'get_bookable_time_slots_for_doctor', true)
        .subscribe((data: any) => {
        if (data && data.is_error == 0) {
            var allAvailableSlots = data.availableSlots;
            if (allAvailableSlots) {
            var trainingDuration = parseInt(data.trainingDuration);
            for (var i = 0; i < this.training_data.length; i++) {
                var shortDate = this.training_data[i].shortDate;
                var dateAvailableSlots = allAvailableSlots[shortDate];
                if (dateAvailableSlots) {

                var availableStartTimes = [];
                for (var j = 0; j < dateAvailableSlots.length; j++) {
                    for (var k = 0; k < dateAvailableSlots[j].length; k++) {
                    var startMinutes = dateAvailableSlots[j][k].startMinutes;
                    var endMinutes = dateAvailableSlots[j][k].endMinutes;

                    if (endMinutes - startMinutes >= trainingDuration) {
                        for (var l = startMinutes; l <= (endMinutes - trainingDuration); l += 15) {
                        var timeSlotHours = parseInt(String(l / 60));
                        var timeSlotMinutes = l % 60;
                        var timeSlotString = (timeSlotHours < 10 ? "0" : "") + timeSlotHours + ":" + (timeSlotMinutes < 10 ? "0" : "") + timeSlotMinutes;
                        if (availableStartTimes.indexOf(timeSlotString) === -1) {
                            availableStartTimes.push(timeSlotString);
                        }
                        }
                    }
                    }
                }
                if (availableStartTimes.length > 0) {
                    var date_parent_time_slots = this.training_data[i].all_slots;
                    for (var j = 0; j < date_parent_time_slots.length; j++) {
                    var childTimeSlots = date_parent_time_slots[j].time_slots;
                    for (var k = 0; k < childTimeSlots.length; k++) {
                        if (availableStartTimes.indexOf(childTimeSlots[k].time_slot) !== -1) {
                        date_parent_time_slots[j].disable = 0;
                        childTimeSlots[k].disable = 0;
                        }
                    }
                    }
                }
                }
            }
            }


        }
        }, (error: any) => {
        console.log(error);
        });
    }

    onDateChange(event) {
    if (event.value !== this.today) {
        let dateVal = event.value
        setTimeout(() => {
        this.selectedDate = this.datepipe.transform(dateVal, 'yyyy-MM-dd', this.timezone);
        var dayOfWeek = dateVal.getDay();
        this.isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
        if (this.isWeekend) {
            this.mainService.customPopups("Please choose another date.Training can't be scheduled on weekend", 1);
            this.training_data.length = 0;
            return false;
        }
        else {
            if (event.value) this.getBookableTimeSlots();
        }
        }, 500);
    }
    }


      openTooltip(event) {
        if(event.target.value == '') return
        let {data, time, index} = JSON.parse(event.target.value)
        this.openboxes = true;
        // this.showConfirm = false;
        this.getDataobject(time.time_slots);
        this.selected_training_data.selected_time_lots = time.time_slots;
        this.selected_training_data.selected_date = data.date;
        this.selected_training_data.selected_index = index;
      }

      getValue(data,time,index) {
        return JSON.stringify({data,time,index})
      }

      confirmBooking() {
        var timezoneParts = this.current_timezone.split("****");
        var timezoneName = timezoneParts[0];
        var tzOffset = parseInt(timezoneParts[1]);
        var timezoneWithCurrentUtcOffset = this.training_timezones.find((timezone) => timezone.tzOffset === tzOffset);
        var selected_full_date_time_string = moment(this.selected_training_data.selected_full_date_time_string).utcOffset(tzOffset).format();
        var reqData = {
          access_token: localStorage.getItem('token'),
          training_type: this.training_type,
          start_date_time: selected_full_date_time_string,
          timezone_full_name: timezoneName,
          timezone_short_name: timezoneWithCurrentUtcOffset.code,
        }
        // if (this.old_event_id) {
        //   reqData['old_event_id'] = this.old_event_id;
        // }
        let doctor_name = this.user_info[0].doctor_first_name + " " + this.user_info[0].doctor_last_name;
        if (this.user_info && this.user_info[0] && this.user_info[0].role_id != 4) {
          if (this.selected_location) {
            reqData['doctor_id'] = this.selected_location;
            let selected_location_1 = this.locations.filter(item => item.doctor_id == this.selected_location);
            doctor_name = selected_location_1[0].doctor_first_name + " " + selected_location_1[0].doctor_last_name;
          } else {
            this.mainService.customPopups('Please select a location', 1);
            return false;
          }
        }
        this.mainService.api(reqData, 'book_doctor_training', true)
          .subscribe((data: any) => {
            if (data && data.is_error == 0) {
                this.training_booked_data = {
                    training_time: moment(this.selected_training_data.selected_full_date_time_string).utcOffset(tzOffset).format("hh:mm A"),
                    training_date: moment(this.selected_training_data.selected_full_date_time_string).utcOffset(tzOffset).format('MMM DD, YYYY'),
                    timezone: timezoneName + " (GMT" + timezoneWithCurrentUtcOffset.timezoneString + ")"
                }
                this.training_booked = 1;
            } else {
              this.mainService.customPopups(data.override_text || data.err, 1);
            }
          }, (error: any) => {
            console.log(error);
          });
      }


      getDataobject(data) {
        let arr = [];

        for (let i = 0; i < data.length; i+=2) {
            // const element = data[i];
            let obj = []

            if(data[i]) {
                obj.push(data[i])
            }

            if(data[i+1]) {
                obj.push(data[i+1])
            }

            arr.push(obj);
        }

        this.availableTimeslots = arr;
    }



      startCountdown(): void {
        this.intervalId = setInterval(() => {
            const now = new Date().getTime();
            const distance = this.countdownDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.remaining_days = days +  this.extra_days
            this.timeRemaining = `${days} days  ${hours} hours remaining`;
            if (distance < 0) {
                clearInterval(this.intervalId);
                this.timeRemaining = 'EXPIRED';
            }
        }, 1000);
    }
    capitalizeFirstLetter(string) {
        if (!string) return string;
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    updateCity(value, type){
        if(!value){
            return;
        }
        // tslint:disable-next-line:max-line-length
        if(value && this.zipCode.city != value && type == 'user_data'){
          this.zip_data.city = value;
          this.getZipCode(this.zip_data, type)
        }
    }

    formatPhoneNumber(phone: string): string {
        if (!phone) return phone;

        const cleaned = phone.replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phone;
      }

    getZipCode(item: any, type?) {
        const combin_data: any = {};
        combin_data[type] = {
          addressObj: item
        }
        this.mainService.api(combin_data, `add_address`, false)
          .subscribe(response => {
            if (!response.is_error) {
              if (response && response.data && response.data.user_data.length) {
                if(type == 'user_data'){
                    this.zip_data = response.data.user_data[0];
                }
              } else {
                // this.setAddress.emit(response);
              }
            } else {
              console.log(response.override_text);
            }
          });
      }

    skipForAr(){
        this.dialogRef.close('skip');
        this.router.navigate(['/app/accounts-receivable/send-invoice']);
    }

    goToInstantPayComponent(){
        this.dialogRef.close();
        this.loaderService.show();
        setTimeout(()=>{
            this.router.navigate(['/app/instant-payout']);
            this.loaderService.hide();
        },500)
    }


    getCardBrandImage(card): string {
        if (card) {
          let brand = (card.brand || card.card.brand).toLowerCase();
          let allowedBrands = ['mastercard', 'discover', 'jcb', 'visa', 'american express', "unionpay", 'diners', 'amex'];
          if (brand === 'american express' || brand == 'amex') {
            return `assets/img/svg/card-type/American Express.svg`;
          }
          if (brand === 'mastercard') {
            return `assets/img/svg/card-type/MasterCard.svg`;
          }
          if (brand === 'unionpay') {
            return `assets/img/svg/card-type/UnionPay.svg`;
          }
          if (brand === 'diners') {
            return `assets/img/svg/card-type/Diners Club.svg`;
          }
          if (brand === 'jcb') {
            return `assets/img/svg/card-type/JCB.svg`;
          }
          return brand && allowedBrands.includes(brand)
            ? `assets/img/svg/card-type/${this.capitalizeFirstLetter(brand)}.svg`
            : 'assets/img/svg/card-type/no_card.svg';
        }
      }

  ClearLoginData() {
    this.mainService.notification_list = [];
    this.mainService.unread_count = 0;
    this.auth.userProfileData$.next(0);
    this.mainService.clearPFData();
    localStorage.removeItem('token');
    localStorage.removeItem('environment');
    localStorage.removeItem('userProfileData');
    localStorage.removeItem('timezone');
    localStorage.removeItem('baseUrl');
    localStorage.removeItem('recurring_extra_amount');
    localStorage.removeItem('locations');
    localStorage.removeItem('departments');
    localStorage.removeItem('roleId');
    localStorage.removeItem('practiceName');
    localStorage.removeItem('globalFilter');
    localStorage.removeItem('locations');
    this.dialogRef.close();
    // this.intercom.shutdown();
    Intercom('shutdown');

  }

  getNonUsCardFee(payment_source_type?:any, source_id?:any) {
    let arrays = this.data.send_data.transactionFeeMetricsArray;

    if (!Array.isArray(arrays)) {
      const stored = localStorage.getItem("transactionFeeMetricsArray");
      arrays = stored ? JSON.parse(stored) : [];
    }

    source_id = source_id || this.data.send_data.source_id;

    if (!payment_source_type && source_id && this.data.send_data.cards) {
      const card = this.data.send_data.cards.find(card => card.source_id === source_id);
      if (card) payment_source_type = card.payment_source_type;
    }

    const m = arrays.find(x => x && x.payment_source_type == payment_source_type) || {};

    return {
      non_us_percent_above_threshold: m.non_us_percent_above_threshold || 0,
      non_us_amount_below_threshold: m.non_us_amount_below_threshold || 0
    };
  }
    goToPayouts() {
        this.loaderService.show();
        this.dialogRef.close()
        const btn = document.getElementById('dashboard_btn');
        if (btn) {
            btn.classList.add("dissolve-animate");
        }
        setTimeout(() => {
            this.router.navigate(['app/reports/view-payouts']);
            this.loaderService.hide();
        }, 800);
    }

    closeInstantPayoutConfirmedModal(){
        this.dialogRef.close()
        this.router.navigate(['/app/dashboard']);
    }

    addAdditionalServices() {
        if(this.show_additional_service) {
            for (let item of this.data.send_data.add_product.additional_products_array) {
                this.setBreakdownVal(item)
            }
            // this.serviceBreakdowns.push(this.createItem());
        } else {
            this.serviceBreakdowns.clear();
        }
    }

    changeServiceType(event: any) {
        this.dynamicPackage.amount_terms_type = event.target.value;
    }


     getLendeeOfferData() {
    return JSON.parse(localStorage.getItem("lendee_offer_status") || "[]");
  }


  startCountdownBuyout() {
    this.time = this.getLendeeOfferData().offers[0].expiry_date;
    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(this.time).getTime() - now;

      if (distance <= 0) {
        this.timerDisplay = "00 Hours : 00 Mins : 00 Secs";
        clearInterval(this.interval);
        if (this.contract.lendee_offer_status == 1) {
          this.contract.lendee_offer_status = 3;
        }
        return;
      }

      const totalSeconds = Math.floor(distance / 1000);
      const hours = Math.floor(totalSeconds / 3600); // Total hours
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.timerDisplay = `${this.pad(hours)} Hours : ${this.pad(
        minutes
      )} Mins : ${this.pad(seconds)} Secs`;
    }, 1000);
  }

  pad(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }


  canCelSubs(result: any, id?: number){

    const obj = {
          access_token: localStorage.getItem('token'),
          id: id ? id : this.data?.subId,
          type: 2,
          is_email_send: result == 2 ? 1 : 0,
          notes: this.cancelNotes,
        };
        this.mainService.api(obj, 'stop_pp_subscription', true)
          .subscribe((data: any) => {
            if (data.is_error) {
              this.mainService.customPopups(data.err, 1);
            } else {
              this.mainService.customPopups('Subscription cancelled successfully', 0);
              // this.getPaymentDetails(this.PP_ID, 0);
              this.dialogRef.close();
            //   this.router.navigate(['/app/process-payment/subscriptions-list']);
            //   this.delete_PP.next(true);
            window.location.reload();
            }
          }, (error: any) => {
            console.log(error);
          });
  }

  ngAfterViewInit() {
    if (this.data && this.data.type == 943) {
      this.startCountdownBuyout();
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

    }


export interface DialogData {
    showCheckbox?: any;
    title?: string;
    desc?: string;
    action?: string;
    actionClass?: string;
    type?: any;
    paymentInfo: boolean;
    send_data?: any;
    popup_data?: { tips_text?: {} }
    email?: any;
    added?: any;
    allContracts?: any;
    downloadPdf?: any;
    noFeePaymentCards?: any;
    customNoFeeAvailableMonth?: any;
    filteredArray?: any;
    paymentType?: any;
    downpaymentCost?: any;
    interestRateAmt?: any;
    doctor_id?: any;
    totalServAmt?: any;
    estimatedServiceCost?: any;
    error?: Boolean;
    error_name?: any,
    url?: any;
    timezones: any;
    getTraningData: any;
    is_ar?: any;
    reasons?: string[];
    downpayment: any,
    selectedPlans: any,
    validateInputData: any,
    service_block: any,
    doctor_data: any
    loan_amount?: any;
    total?: any;
    queryParam?: any;
    bgImage?: any;
    subId?: any;
    isPPSub?: any;
}
